var SirionUtils = new (function () {
    var self = this;
    self.scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
    this.IS_FIRST_CALL = "isFirstCall";
    this.DEFAULT_PAGE_SIZE = 50;
    this.AE_ASYNC_LISTING_SIZE = 50;
    this.DUPLICATE_REQUEST_TIME = 180000;
    this.sseSubscribeURLEventDetail = {};
    this.LIST_USER_ICON = '<span><img loading="lazy" alt="Group Avatar" class="sirion_avatar avatar_size" src="src/react/src/CSS/images/User_group.svg"></span>';
    this.LIST_USER_REPLACE_TEXT = '#GROUP#';
    /** In-memory only — last job-scheduler listing params for bulk payloads (no localStorage/sessionStorage). */
    this._bulkJobSchedulerListingCtx = null;
    /** In-memory — requestId whose scheduler bulk payload was already consumed after a successful POST. */
    this._bulkJobSchedulerConsumedRequestId = null;
    this.checkUndefAndNull = function (strValue) {
        if (strValue != null && strValue != undefined) {
            return true;
        } else {
            return false;
        }
    }
    //function for calculating offset of a child wrt parent
    this.getElmPosRespectToParent = (elm, parentElmIdentifier) => {
        let $ = window.$,
            winH = $(window).height(),
            element = $(elm),
            elePosObj = elm.getBoundingClientRect(),
            elementHeight = elePosObj.height,
            elementLeftVP = elePosObj.left, // Respect to view Port
            elementTopVP = elePosObj.top, // Respect to view Port
            elementPosFromTop = element.offset().top,
            parentElmJQ = $(elm).closest(parentElmIdentifier),
            parentElm = parentElmJQ[0],
            parentElmPosObj = parentElm.getBoundingClientRect(),
            parentElmHeight = parentElmJQ.height(),
            elePosFromBottom = parentElmHeight - (elementPosFromTop - parentElmPosObj.top), // Respect to parent Element
            elePosFromBottomVP = winH - elePosObj.top - element.height(), // Respect to view Port
            parentPosFromBottomVP = winH - parentElmPosObj.top - parentElmHeight; // Respect to view Port

        return {
            elementHeight,
            elePosFromBottom,
            elePosFromBottomVP,
            parentElmHeight,
            elementLeftVP,
            elementTopVP,
            parentPosFromBottomVP,
            windowHeight: winH
        }
    }

    this.storePreviousPageURL = (fromWFlist) => {
        let previousURL = window.location.hash.split('#')[1].split('?')[0];
        if(fromWFlist){
            previousURL = window.sessionStorage.getItem('raiserequestBaseUrl')?.substr(2);
        }
        sessionStorage.setItem('previousURL', previousURL);
    }

    this.openCreateFromList = (scope,url,appendRest,label,$window,entityTypeId,fromAEShowPage,fromWFlist = false)=> {
        if(!window.location.href.includes('raise')) {
            window.sessionStorage.setItem('raiserequestBaseUrl', window.location.href && window.location.href.split(`/${envAlias}`)[1]);
        }
        if(window.location.href.indexOf('create/tblcdr') > -1 && (!entityTypeId || entityTypeId == 160))
            return;
        const entitiesForCustomAPIurl = ['tblclause','tblcontracttemplate'];
        let entitiesForCustomApiFlag = false;
        scope.isCdr = url.includes('tblcdr/create');
        let listId = fromAEShowPage ? entityTypeId : entityTypeIdToListIdMapper[entityTypeId]  || +scope.listId;
        let updatedUrl = url;
        let sc = $("#filterDiv").scope();
        entitiesForCustomAPIurl.forEach(function(str){
            if(url.includes(str + '/create')){
                entitiesForCustomApiFlag = true;
                scope.createWithWorkflow(url,true);
            }
        })
        const isNotWorkflowOneDotO = url.split('/').pop().length < 2 || listId !=2|| url.indexOf('tblcdr/create');
        if(entitiesForCustomApiFlag) return;
        if(url.indexOf("/createForm") > -1){
            updatedUrl = url.replace("/createForm","/createForm/rest");
        } else if(appendRest && isNotWorkflowOneDotO && !fromWFlist && !url.includes('contractFreeCreate')) {
            updatedUrl = url + (sc && sc.vendorNonMandatory && url.indexOf('tblcdr/create') == -1 ? "" : "/rest");
        }
        if (!label && scope.isPlusIconTitle && scope.isPlusIconTitle.indexOf(intl_msg[25535]) == -1) {
            label = intl_msg[25535] + ' ' + scope.isPlusIconTitle;
        }
        if(updatedUrl.indexOf('/tblcdr/create') > -1) {
            listId = 279;
        }
        if (url.indexOf('/externalcontact') > -1 || url.indexOf("/externalContactFreeCreate") > -1) {
            $window.jsonApi = url;
            if(label){
                scope.isPlusIconTitle = label;
            }
            else if (scope.isPlusIconTitle && scope.isPlusIconTitle.indexOf(intl_msg[25535]) == -1) {
                scope.isPlusIconTitle = intl_msg[25535] + ' ' + scope.isPlusIconTitle;
            }
            scope.showCreateDialog.visible = true;
            return;
        }
        this.clearAEObjectFromSessionStorage();
        if(fromAEShowPage){
            let aeDocObject ={aeEntityTypeId:scope.entityTypeId, aeDocId:scope.entityId};
            sessionStorage.setItem('aeDocObject', JSON.stringify(aeDocObject));
            sessionStorage.setItem('fromAEShowPage', true);
        }

        this.storePreviousPageURL(fromWFlist);
        sessionStorage.setItem('api',encodeURIComponent(updatedUrl));
        if(!fromWFlist) {
            sessionStorage.setItem('wfFreeFormAPI', encodeURIComponent(updatedUrl));
        }
        const _url =  listIdToEntityDataMapper?.[listId]?.url;
        if(window.location.href.includes('raise')) {
            window.location.replace(addtStamp(`/${envAlias}/#/create/${_url}`,true));
        }
        window.location.href = addtStamp(`/${envAlias}/#/create/${_url}`,true);
        if(label){
            sessionStorage.setItem('pageLabel',label);
        }

        return;
    }
    this.handleExceptionErrors = function (response, isCreateRoute) {
        stopLoader();
        if (response) {
            window.systemWarning(response.responseCode + " " + response.value);
            if (response.message != null || response.errorMessage || _.get(response,'errorMessage.errorMessage')) {
                if(this.isArray(response.errorMessage)){
                    const errorMessage = response.errorMessage.reduce((acc, error) => {
                        acc = acc + (acc ? (", " + error.errorMessage) : error.errorMessage);
                        return acc;
                    },'')
                    Toaster.create(errorMessage, {iconClass: "icon-Information_filled"});
                } else {
                    Toaster.create(intl_msg[response.labelId] || response.message || _.get(response,'errorMessage.errorMessage') || response.errorMessage , {iconClass: "icon-Information_filled"});
                }
            }
            if (response.redirectTo != null || response.redirect) {
                if (response.redirectTo == "home") {
                    window.location.href = "#";
                } else if (response.redirect) {
                    const sc = $('ng-view').scope();
                    if(sc && sc.previousRoute?.params?.entityId == SirionUtils.getEntityIdFromUrl()) {
                        if(window.location.href.indexOf('update/project') > -1) {
                            sc?.goToPreviousRoute?.();
                        }
                        if(_.get(urlToEntityDataMapper, `${sc.previousRoute?.params?.entityName}`)) {
                            const listId = urlToEntityDataMapper[sc.previousRoute.params.entityName].listId;
                            window.location.href = `#/listRender/${listId}`;
                        }
                        return;
                    }
                    if(isCreateRoute) {
                        sc?.goToPreviousRoute?.();
                    }else{
                        const sc = $('#ngViewID').scope()
                        sc?.goToPreviousPage?.();
                    }
                } else if (response.location != null) {
                    window.location.href = response.location;
                }
            }
        }
    };
    //function to prepare postData for final createAPI in case of CDRUpload
    this.prepareFinalCreatePostData = function (sc, fileData) {
        let that = sc;
        let postData = [];
        let fileDataToPost = angular.copy(fileData);
        for (var dataItem in fileDataToPost) {
            fileDataToPost[dataItem]["performanceData"] = false;
            fileDataToPost[dataItem]["searchable"] = false;
            fileDataToPost[dataItem]['autoRedLineDocument'] = fileDataToPost[dataItem]['autoRedLineDocumentChecked'] || false;
            // fileData[dataItem]['shareWithSupplierFlag'] = fileData.;
            fileDataToPost[dataItem]['triggerAutoExtraction'] = fileDataToPost[dataItem]['extractMetadata'] || false;
            delete fileDataToPost[dataItem]["$$hashKey"];
            // delete fileData[dataItem]["documentName"];
            delete fileDataToPost[dataItem]["documentStatus"];
            delete fileDataToPost[dataItem]["docTagTempData"];
            delete fileDataToPost[dataItem].origDeviationVal;
        }
        angular.forEach(fileDataToPost, function (obj) {
            obj.selectedclassification?.forEach(function (c) {
                obj[c.val] = true
            })
            obj.documentTags = obj.documentTags ? obj.documentTags.map(function (d) {
                return d.id.toString();
            }) : [];
            delete obj.selectedclassification;
            delete obj.classification;
            delete obj.classOptions;
        });
        postData = fileDataToPost;
        return postData
    }

    this.deleteCookie = function (name) {
        document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    this.getSelectedColumnsInCurrentOrder = function (listJson) {
        try {
            var idToColMeta = {};
            if (listJson && Array.isArray(listJson.columns)) {
                for (var i = 0; i < listJson.columns.length; i++) {
                    var col = listJson.columns[i];
                    idToColMeta[col.id] = col;
                }
            }
            var selectedColsOrdered = [];
            var $ths = window.$(".dataTables_scrollHeadInner").find("th");
            $ths.each(function () {
                var colIdAttr = window.$(this).attr("data-col-id");
                if (!colIdAttr) return;
                var colIdNum = Number(colIdAttr);
                var meta = idToColMeta[colIdNum];
                if (meta && meta.queryName !== "bulkcheckbox") {
                    selectedColsOrdered.push({ columnId: meta.id, columnQueryName: meta.queryName });
                }
            });
            return selectedColsOrdered;
        } catch (e) {
            return [];
        }
    }

    this.getAvatarImage = function (name) {
        const privateUtil = {
            getInitials: (string = "") => {
                let wordCount = 0,
                    wordCountToLookFor = 2,
                    initials = string
                        .split(" ")
                        .reduce((acc, curr, idx) => {
                            if (curr[0] && wordCount < wordCountToLookFor) {
                                acc += (curr[0].trim()).toUpperCase();
                                wordCount++;
                            }
                            return acc;
                        }, "")
                return initials;
            },

            getBgColor: (string, allColors) => {
                let n = string.length,
                    charIndex = 0,
                    colorIndex;
                for (let i = 0; i < n; i++)
                    charIndex = string.charCodeAt(i);
                colorIndex = charIndex % allColors.length;
                return allColors[colorIndex];
            },

            getImage: (name) => {
                const WIDTH = 256,
                    HEIGHT = 256,
                    FONT_SCALE = 100,
                    FONT_WEIGHT = 100,
                    TEXT_COLOR = "#fff",
                    PICTURE_FORMAT = "png",
                    INITIALS = name && privateUtil.getInitials(name),
                    ALL_COLORS = [
                        "#bdc3c7", "#6f7b87", "#2c3e50", "#2f3193", "#662d91",
                        "#922790", "#ec2176", "#ed1c24", "#f36622", "#f8941e",
                        "#fab70f", "#fdde00", "#d1d219", "#8ec73f", "#00a650",
                        "#00aa9c", "#00adef", "#0081cd", "#005bab"
                    ],
                    BACKGROUND = privateUtil.getBgColor(INITIALS, ALL_COLORS),
                    FONT_SIZE = WIDTH / (2 / (FONT_SCALE / 100));
                const canvas = document.createElement('canvas');
                canvas.width = WIDTH;
                canvas.height = HEIGHT;
                const ctx = canvas.getContext('2d');
                ctx.fillStyle = BACKGROUND;
                ctx.fillRect(0, 0, WIDTH, HEIGHT);
                ctx.font = FONT_WEIGHT + " " + FONT_SIZE + "px sans-serif";
                ctx.textAlign = "center";
                ctx.fillStyle = TEXT_COLOR;
                ctx.fillText(INITIALS, WIDTH / 2, HEIGHT - HEIGHT / 2 + FONT_SIZE / 3);
                return canvas.toDataURL("image/" + PICTURE_FORMAT);
            }
        }
        const imgData = privateUtil.getImage(name);
        return imgData;
    }

    this.setCookie = function (name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + ";domain=" + location.hostname + "; path=/";
    }

    this.checkNullEmptyAndUndefined = function (strValue) {
        var retVal = false;
        if (strValue != "null" && strValue != null && strValue != "undefined" && strValue != undefined && strValue != '') {
            retVal = true;
        }
        return retVal;
    }

    this.getCookieValue = function (a) {
        var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
        return b ? b.pop() : '';
    }

    this.isJSONEmpty = function (obj) {
        if (Object.keys(obj).length === 0)
            return true;
        else return false;
    }

    this.isArray = function (val) {
        return typeof val === 'object' && val instanceof Array && val.length != undefined;
    };
    this.isObject = function (val) {
        return typeof val === 'object' &&
            !(val instanceof Array) &&
            val instanceof Object && val.length == undefined;
    };
    this.isString = function (val) {
        var retVal = false;
        if ((typeof val === "string" || val instanceof String || typeof val == "object")
            && Object.prototype.toString.call(val) === "[object String]" &&
            !(self.isArray(val)) &&
            val.constructor === String) {
            // it's a string
            retVal = true;
        }
        return retVal;
    }

    this.checkIfNumber = function (val) {
        var retVal = false;
        if ((typeof val === "number" || val instanceof Number || typeof val == "object")
            && Object.prototype.toString.call(val) === "[object Number]" &&
            !(isArray(val)) &&
            isFinite(val) &&
            Math.floor(val) === val &&
            val.constructor === Number) {
            // it's a string
            retVal = true;
        }
        return retVal;
    }

    this.checkIfBoolean = function (bool) {
        var retVal = false;
        if ((typeof bool === 'boolean' || (typeof bool === 'object' && typeof bool.valueOf() === 'boolean'))
            && Object.prototype.toString.call(bool) === "[object Boolean]" &&
            !(isArray(bool)) &&
            bool.constructor === Boolean
        ) {
            retVal = true;
        }
    }

    this.checkIfUndefined = function (valArgs) {

        var retVal = false;
        if (typeof valArgs === "undefined"
            && valArgs === undefined
            && Object.prototype.toString.call(valArgs) === "[object Undefined]"
            && valArgs === void 0
        ) {
            retVal = true;
        }
        return retVal;
    }

    this.getTypeOf = function (obj) {
        return {}.toString.call(obj).split(' ')[1].slice(0, -1).toLowerCase();
    }
    /**
     * Checks if `value` is empty. Arrays, strings, or `arguments` objects with a
     * length of `0` and objects with no own enumerable properties are considered
     * "empty".
     *
     * @static
     * @memberOf _
     * @category Objects
     * @param {Array|Object|string} value The value to inspect.
     * @returns {boolean} Returns `true` if the `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty([]);
     * // => true
     *
     * _.isEmpty({});
     * // => true
     *
     * _.isEmpty('');
     * // => true
     */
    this.findSpecificFieldProperty = function (data, fieldId, fieldName, propertyName) {
        if (data.id === fieldId && data.name === fieldName) {
            return _.get(data, propertyName);
        } else if (data && data.hasOwnProperty('fields')) {
            for (var i = 0; i < data.fields.length; ++i) {
                var returnedValue = this.findSpecificFieldProperty(data.fields[i], fieldId, fieldName, propertyName);
                if (returnedValue != null && returnedValue != undefined)
                    return returnedValue;
            }
        }
    }
    this.isEmpty = function (value) {
        if (!value) {
            return true;
        }
        if (_.isNumber(value)) {
            return !value;
        }
        if (self.isArray(value) || self.isString(value)) {
            return !value.length;
        }
        for (var key in value) {
            if (hasOwnProperty.call(value, key)) {
                return false;
            }
        }
        return true;
    };

    this.stripScripts = function (text) {
        while (self.scriptRegex.test(text)) {
            text = text.replace(self.scriptRegex, "");
        }
        return text;
    };

    this.formatWithComma = function (val) {
        var currentFormatLocale = currentNumberFormat;
        var outputNumber = "";
        if (val || val === 0) {
            if (currentFormatLocale != "noFormat") {
                const parts = String(val).split("."),
                    formattedNumber = Number(parts[0]).toLocaleString(currentFormatLocale);
                outputNumber = formattedNumber + (parts[1] !== undefined ? "." + parts[1] : "");
            } else {
                outputNumber = val.toString();
            }
            if (outputNumber[0] == "-") {
                if (negativeNumberSymbol == 1) {
                    outputNumber = outputNumber.replace(/-/, "(");
                    return outputNumber + ")";
                } else {
                    return outputNumber;
                }
            } else {
                return outputNumber;
            }
        } else {
            return "";
        }
    };
    this.unFormatNumber = function (value) {
        var decimal = ".";
        var currentFormatLocale = currentNumberFormat;
        if (currentFormatLocale == 'de-CH') {
            decimal = ",";
        }
        value = value || 0;

        // Return the value as-is if it's already a number:
        if (typeof value === "number") return value;

        // Build regex to strip out everything except digits, decimal point and minus sign:
        var regex = new RegExp("[^0-9-" + decimal + "]", ["g"]),
            unformatted = parseFloat(
                ("" + value)
                    .replace(/\((.*)\)/, "-$1") // replace bracketed values with negatives
                    .replace(regex, '')         // strip out any cruft
                    .replace(decimal, '.')      // make sure decimal point is standard
            );

        // This will fail silently which may cause trouble, let's wait and see:
        return !isNaN(unformatted) ? unformatted : 0;
    };

    this.setCheckBoxTrue = function (element) {
        element.prop("checked", true);
        self.setCheckBoxIndeterminate(element, false);
    };

    this.setCheckBoxFalse = function (element) {
        element.prop("checked", false);
        self.setCheckBoxIndeterminate(element, false);
    };

    this.setCheckBoxIndeterminate = function (element, val) {
        element.prop("indeterminate", val);
        if (val == true) {
            element.prop("checked", true);
        }
    };

    this.getColumnClassName = function (value) {
        var type_class = "";
        var retval = "";
        try {
            if (value && value.displayFormat) {
                var json = JSON.parse(value.displayFormat);
            }

            if (json && json.type) {
                type_class = "col_type_" + json.type + " "
            }
        } catch (e) {
            if (typeof console != "undefined") {
                console.log(e);
            }
        }
        if (value) {
            if (value.queryName != null) {
                retval = type_class + "col_wrap_" + value.queryName.trim();
            } else {
                retval = type_class + "col_wrap_" + (value.name != null) ? value.name.trim() : "";
            }

        }
        return retval;
    };

    this.convertValueToNumber = function (value) {

    };
    this.checkFieldRecursively = function (object, arr, ind, type) {
        var res = type ? undefined : false;
        if (ind == arr.length) {
            return type ? object : true;
        } else {
            if (arr[ind] in object) {
                if (object[arr[ind]] && typeof (object[arr[ind]]) == "object" && Object.keys(object[arr[ind]]).length > 0)
                    res = this.checkFieldRecursively(object[arr[ind]], arr, ind + 1, type);
                else if (ind + 1 == arr.length)
                    return type ? object[arr[ind]] : true;
                else
                    return type ? undefined : false;
            }
        }
        return res;
    };

    /*to check existence of field in object(always return true or false)
* example:
* obj = {"a":{"b":"name"},"c":{}};
* checkExistenceOfFieldNDepth(obj,"a.b"), o/p true
* checkExistenceOfFieldNDepth(obj,"a.f"), o/p false
* */
    this.checkExistenceOfFieldNDepth = function (obj, field) {
        if (!obj || Object.keys(obj).length == 0 || !field || field == "")
            return false;
        else {
            var fieldArr = field.split("."), ind = 0;
            return this.checkFieldRecursively(obj, fieldArr, ind);
        }
    };


    /*to get value of field in object(always return value or undefined)
 * example:
 * obj = {"a":{"b":"name"},"c":{}};
 * getValueOffieldNDepth(obj,"a.b"), o/p "name"
 * getValueOffieldNDepth(obj,"a.f"), o/p undefined
 * */
    this.getValueOffieldNDepth = function (obj, field) {
        if (!obj || Object.keys(obj).length == 0 || !field || field == "")
            return undefined;
        else {
            var fieldArr = field.split("."), ind = 0;
            return this.checkFieldRecursively(obj, fieldArr, ind, "get");
        }
    }

    this.setValueOfNDepth = function (obj, field, value) {
        if (!obj || Object.keys(obj).length == 0 || !field || field == "")
            return undefined;
        else {

            var fieldArr = field.split("."), ind = 0;
            if (fieldArr.length > 1) {
                //Fetch parent of target object.
                var splicedElement = fieldArr.splice(fieldArr.length - 1, 1);
                var parentValue = this.checkFieldRecursively(obj, fieldArr, ind, "get");
                if (parentValue) {
                    parentValue[splicedElement] = value;
                }
                return;
            }
        }
    }

    this.compareStrings = function (string1, string2, ignoreCase, useLocale) {
        if (ignoreCase) {
            if (useLocale) {
                string1 = string1.toLocaleLowerCase();
                string2 = string2.toLocaleLowerCase();
            } else {
                string1 = string1.toLowerCase();
                string2 = string2.toLowerCase();
            }
        }

        return string1 === string2;
    }

    /******** Estimate/calculate difference of drop-down height and window height ********/
    this.openDropDownUpwards = function (parentElmClass, targetElementId, baseElmHeight) {
        var windowHeight = $(window).height();
        var mousePointerTop = $("." + parentElmClass).offset().top;
        var elemOuterHeight = $("#" + targetElementId + ' ul').outerHeight();
        var baseElemHeight = baseElmHeight != (undefined || null) ? baseElmHeight : 0;
        var styleObj = {};
        if (windowHeight < mousePointerTop + elemOuterHeight) {
            var topV = elemOuterHeight + baseElemHeight + 20;
            styleObj = {
                "top": -topV,
                "position": "relative",
                "left": 'auto'
            }
        }
        $("#" + targetElementId).css(styleObj);
    };
    this.findInArray = function (masterArray, _id, _specificKey) {
        var retObj = {};
        if (masterArray == undefined || self.isEmpty(masterArray)) {
            return retObj;
        }
        for (var x = 0; x < masterArray.length; x++) {
            if (_specificKey == "none") {
                if (masterArray[x] == _id) {
                    retObj = masterArray[x];
                    break;
                }
            }
            if (masterArray[x].id == _id || masterArray[x].filekey == _id || masterArray[x][_specificKey] == _id) {
                retObj = masterArray[x];
                break;
            }
        }
        return retObj;
    };

    this.compareJson = function (_json1, _json2) {
        return (self.compareCollection(_json1, _json2) && _.isEqual(_json1, _json2));

    };
    // Compare two items
    this._sirionCompare = function (item1, item2) {

        // Get the object type
        var itemType = Object.prototype.toString.call(item1);
        // If an object or array, compare recursively
        if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
            if (!self.compareCollection(item1, item2)) return false;
        }
        // Otherwise, do a simple comparison
        else {
            // If the two items are not the same type, return false
            if (itemType !== Object.prototype.toString.call(item2)) return false;

            // Else if it's a function, convert to a string and compare
            // Otherwise, just compare
            if (itemType === '[object Function]') {
                if (item1.toString() !== item2.toString()) return false;
            } else {
                if (item1 !== item2) {
                    /*console.log("item1 "+item1+" item2 "+item2);*/
                    return false;
                }
                ;

            }

        }
    };


    this.compareCollection = function (value, other) {

        // Get the value type
        var type = Object.prototype.toString.call(value);

        // If the two objects are not the same type, return false
        if (type !== Object.prototype.toString.call(other)) {
            /*console.log(" In compareCollection the type is not matching, it is . "+type);*/
            return false;
        }

        // If items are not an object or array, return false
        if (['[object Array]', '[object Object]'].indexOf(type) < 0) {
            /*console.log(" In compareCollection the type is not among array and object,it is . "+type);*/
            return false;
        }

        // Compare the length of the length of the two items
        var valueLen = type === '[object Array]' ? value.length : Object.keys(value).length;
        var otherLen = type === '[object Array]' ? other.length : Object.keys(other).length;
        if (valueLen !== otherLen) {
            /*console.log("valueLen "+valueLen+" otherLen "+otherLen);*/
            return false;
        }

        // Compare properties
        if (type === '[object Array]') {
            for (var i = 0; i < valueLen; i++) {
                if (self._sirionCompare(value[i], other[i]) === false) {
                    /*console.log("value[i] "+value[i]+" other[i] "+other[i]);*/
                    return false;
                }
            }
        } else {
            for (var key in value) {
                if (value.hasOwnProperty(key)) {
                    if (self._sirionCompare(value[key], other[key]) === false) {
                        /*console.log(" key "+key+" value1 "+value[key]+" other1 "+other[key]);*/
                        return false;
                    }
                }
            }
        }
        // If nothing failed, return true
        return true;

    };


    this.appendDocProperties = function (obj, DATA_SCOPE, docTagReq, layoutData) {
        var propLi = "", docTagLi = "", combinedLi;
        var itemArray = obj && obj["fields"];
        var caption = obj["label"];
        angular.forEach(itemArray, function (obj, i) {
            if (obj.displayMode != "display") {
                if (propLi == "") {
                    propLi += "<li class='li_caption' " + ' ' + "><small title='" + caption + "' > " + caption + " </small></li>";
                }
                propLi += "<li class='file_upload_li' " + ' ng-click=\"updateDocObj(\'' + obj.id + '' + '\',$event)\" ' + " id='" + obj.id + "'> <input type=\"checkbox\"  class=\"show_alter_image " + obj.name + "\"" +
                    " /><span></span><small title='" + obj.label + "' id='" + obj.id + "'> " + obj.label + " </small></li>";
            }
        });
        var docTagArray = [], docTagCaption = "";
        if (DATA_SCOPE && _.has(DATA_SCOPE, "comment.documentTags['options']['data']")
            && layoutData && SirionUtils.checkForDocTagPermission(layoutData)) {
            docTagArray = DATA_SCOPE.comment.documentTags['options']['data'];
            docTagCaption = intl_msg[29235] || "Document Category" || DATA_SCOPE.comment.documentTags["name"];
            angular.forEach(docTagArray, function (obj, i) {
                if (docTagLi == "") {
                    docTagLi += "<li class='li_caption' " + ' ' + "><small title='" + docTagCaption + "' > " + docTagCaption + " </small></li>";
                }
                docTagLi += "<li class='doc_tag_li'" + ' ng-click=\"updateDocObj(\'' + obj.id + '' + '\',$event)\" ' + " " +
                    "data-option-id='" + obj.id + "'> " +
                    "<input type=\"checkbox\"  class=\"show_alter_image " + obj.name + "\"" +
                    "/><span></span><small title='" + obj.name + "' id='" + obj.id + "'> " + obj.name + " </small></li>";
            });
        }
        if (DATA_SCOPE && _.has(DATA_SCOPE, "comment.documentTags['options']['data']")
            && docTagReq && layoutData && SirionUtils.checkForDocTagPermission(layoutData)) {
            combinedLi = propLi + docTagLi;
        } else {
            combinedLi = propLi;
        }
        var htmlForProperties = '<span id="filePropertiesSpan"><ul id="fileProperties"  class="file-upload drop-down">' + combinedLi + '</ul></span>';
        return htmlForProperties;
    };

    this.appendDocTagsOnly = function (NEW_ELEM, DOC_TAG_DATA) {
        if (SirionUtils.isEmpty(DOC_TAG_DATA) || !_.has(DOC_TAG_DATA, '["options"]["data"]')) {
            return "";
        }
        var docTagArray = DOC_TAG_DATA['options']['data'];
        var caption = intl_msg[29235] || "Document Category" || DOC_TAG_DATA["name"];
        var innerLi = "", htmlForProperties = "";
        if (docTagArray.length) {
            angular.forEach(docTagArray, function (obj, i) {
                if (innerLi == "") {
                    innerLi += "<li class='li_caption' " + ' ' + "><small title='" + caption + "' > " + caption + " </small></li>";
                }
                innerLi += "<li class='doc_tag_li'" + ' ng-click=\"updateDocObj(\'' + obj.id + '' + '\',$event)\" ' + " " +
                    "data-option-id='" + obj.id + "'> " +
                    "<input type=\"checkbox\"  class=\"show_alter_image " + obj.name + "\"" +
                    "/><span></span><small title='" + obj.name + "' id='" + obj.id + "'> " + obj.name + " </small></li>";
            });
            htmlForProperties = '<span id="filePropertiesSpan"><ul id="fileProperties"  class="file-upload drop-down">' + innerLi + '</ul></span>';
        }
        return htmlForProperties;
    };

    this.getFinalURL = function (baseURL, scope, _attr) {
        /*******
         * ****To Handle Account Page Schedules Tab Api's
         * Gives 400{BAD RREQUEST} on appending version=2.0
         * ******************/
        if (_attr.$attr && _attr.$attr["isscheduletable"] && _attr.$attr["isscheduletable"] == "isscheduletable") {

            return baseURL;
        } else {
            return baseURL + (scope.firstCall ? "?" + self.IS_FIRST_CALL + "=true&version=2.0" : (baseURL.indexOf("?") == -1 ? "?version=2.0" : "&version=2.0"));
        }
    };

    this.refreshFavourite = function (args) {
        if (args == "private") {
            $(".showPrivate").show();
            $(".showPublic").hide();
            if ($(".showPublic").length > 0) {
                if ($('ul.showPublic li').length == 1) {
                    $('ul.showPublic li.noViews').show();
                }
            } else {
                $('ul.showPrivate li[public=true]').hide();
                if ($('ul.showPrivate li[public=false]').length <= 1) {
                    $('ul.showPrivate li.noViews').removeClass("displayNoneNoViews");
                }
            }
            $('li.resetView').addClass("displayNone");

        } else {
            $(".showPrivate").hide();
            $(".showPublic").show();
            if ($('ul.showPublic').length > 0) {
                if ($('ul.showPublic li').length > 1) {
                    $('ul.showPublic li.noViews').addClass("displayNoneNoViews");
                } else if ($('ul.showPrivate li').length > 1) {
                    $('ul.showPrivate li.noViews').addClass("displayNoneNoViews");
                }
            } else {
                $('ul.showPrivate li[public=true]').show();
                if ($('ul.showPrivate li').length > 1) {
                    $('ul.showPrivate li.noViews').addClass("displayNoneNoViews");
                }
            }
            $('li.resetView').removeClass("displayNone");
        }
    }

    this.isWordPluginPage = function () {
        if (typeof wordPluginPage == "undefined") {
            return false;
        }
        return wordPluginPage;
    }

    this.addScrollBarCss = function (iframeDocument) {
        var scrollStyle = "::-webkit-scrollbar { height: 10px; overflow: visible; width: 10px; background: #fff; } ::-webkit-scrollbar-button { display: none; height:0; width: 0; } ::-webkit-scrollbar-track { -moz-background-clip: border; -webkit-background-clip: border; background-clip: border-box; border-width: 0 0 0 4px; border: solid transparent; } ::-webkit-scrollbar-track:hover { background-color:rgba(0,0,0,.05); } ::-webkit-scrollbar-track:active { background-color:rgba(0,0,0,.05); } ::-webkit-scrollbar-thumb { -moz-background-clip: border; -webkit-background-clip: border; background-clip: border-box; background-color: rgba(0,0,0,.2); /*border-width: 1px 1px 1px 6px; border: solid transparent;*/ -moz-box-shadow: inset 1px 1px 0 rgba(0,0,0,.1),inset 0 -1px 0 rgba(0,0,0,.07); -webkit-box-shadow: inset 1px 1px 0 rgba(0,0,0,.1),inset 0 -1px 0 rgba(0,0,0,.07); box-shadow: inset 1px 1px 0 rgba(0,0,0,.1),inset 0 -1px 0 rgba(0,0,0,.07); min-height: 28px; padding: 100px 0 0; -webkit-border-radius: 3px; } ::-webkit-scrollbar-thumb:hover { background-color:rgba(0,0,0,.4); -moz-box-shadow: inset 1px 1px 1px rgba(0,0,0,.25); -webkit-box-shadow: inset 1px 1px 1px rgba(0,0,0,.25); box-shadow: inset 1px 1px 1px rgba(0,0,0,.25); } ::-webkit-scrollbar-thumb:active { background-color:rgba(0,0,0,0.5); -moz-box-shadow: inset 1px 1px 3px rgba(0,0,0,0.35); -webkit-box-shadow: inset 1px 1px 3px rgba(0,0,0,0.35); box-shadow: inset 1px 1px 3px rgba(0,0,0,0.35); } ::-webkit-scrollbar-thumb:horizontal { border-width: 6px 1px 1px; -moz-box-shadow: inset 1px 1px 0 rgba(0,0,0,.1), inset -1px 0 0 rgba(0,0,0,.07); -webkit-box-shadow: inset 1px 1px 0 rgba(0,0,0,.1), inset -1px 0 0 rgba(0,0,0,.07); box-shadow: inset 1px 1px 0 rgba(0,0,0,.1), inset -1px 0 0 rgba(0,0,0,.07); padding: 0 0 0 100px; } ::-webkit-scrollbar-corner { background: transparent; } ::-webkit-scrollbar-track-piece { -moz-background-clip: border; -webkit-background-clip: border; background-clip: border-box; background-color: #f5f5f5; /*border-width: 0 0 0 3px; border: solid #fff;*/ -moz-box-shadow: inset 1px 0 0 rgba(0,0,0,.14), inset -1px 0 0 rgba(0,0,0,.07); -webkit-box-shadow: inset 1px 0 0 rgba(0,0,0,.14), inset -1px 0 0 rgba(0,0,0,.07); box-shadow: inset 1px 0 0 rgba(0,0,0,.14), inset -1px 0 0 rgba(0,0,0,.07); } ::-webkit-scrollbar-track-piece:horizontal { border-width:3px 0 0; -moz-box-shadow: inset 0 1px 0 rgba(0,0,0,.14), inset 0 -1px 0 rgba(0,0,0,.07); -webkit-box-shadow: inset 0 1px 0 rgba(0,0,0,.14), inset 0 -1px 0 rgba(0,0,0,.07); box-shadow: inset 0 1px 0 rgba(0,0,0,.14), inset 0 -1px 0 rgba(0,0,0,.07); } ::-webkit-scrollbar-thumb { border-width: 1px 1px 1px 5px; } ::-webkit-scrollbar-thumb:horizontal { border-width: 5px 1px 1px; } ::-webkit-scrollbar-corner { -moz-background-clip: border; -webkit-background-clip: border; background-clip: border-box; background-color: #f5f5f5; border-width: 10px 0 0 10px; border: solid #fff; -moz-box-shadow: inset 1px 1px 0 rgba(0,0,0,.14); -webkit-box-shadow: inset 1px 1px 0 rgba(0,0,0,.14); box-shadow: inset 1px 1px 0 rgba(0,0,0,.14); }",
            divNode = document.createElement("div");
        divNode.innerHTML = "<br><style>" + scrollStyle + "</style>";
        iframeDocument.body.appendChild(divNode);
    }

    this.fillUserDynamicData = function (filledData, objData) {
        Object.keys(filledData).forEach(function (key, index) {
            var type = objData[key] && objData[key]["htmlType"].name;
            if (type == "Single Select") {
                $("#" + key).text(filledData[key]["values"]["name"]);
            } else if (type == "Multi Select") {
                var arr = "";
                for (var i = 0; i < filledData[key]["values"]?.length; i++) {
                    arr += filledData[key]["values"][i]["name"] + ", ";
                }
                arr = arr.substr(0, arr.length - 2);
                $("#" + key).text(arr);
            } else if (type == "Check Box") {
                filledData[key]["values"] == true ? $("#" + key).text(intl_msg[25815]) : $("#" + key).text(intl_msg[25816]);
            } else {
                $("#" + key).text(filledData[key]["values"]);
            }
        });
    }
    /* Accepts Dynamic Meta Data as objData */
    this.initUserDynamicData = function (objData) {
        var html = "";
        var openTr = false;
        Object.keys(objData).forEach(function (key, index) {
            if (index % 2 == 0 && !openTr) {
                openTr = true;
            }
            html += '<label>';
            html += '<span class ="fieldLabel"><span class="restrictWidth"> ' + objData[key]["displayName"] + " :" + ' </span>  </span>';
            html = html + "<span class='description'> <span ng-disable='true' id='" + objData[key]["apiName"] + "'></span></span>";
            html += "</label>";
            if (index % 2 == 1 && openTr) {
                openTr = false;
            }
        });
        if (openTr) {
            html += "</tr>";
        }
        $(".additionalDetails").html(html);
        self.dateINIT("useDatepicker");
    }
    this.dateINIT = function (selector) {
        var dateToday = new Date();
        $("." + selector).datepicker();
    }

    this.getTotalPages = function (ids, pageSize) {
        return Math.ceil(ids.length / pageSize);
    };

    this.fetchIdsForPage = function (ids, pageSize, pageNum) {
        if (!ids) {
            return;
        }
        return ids.splice((pageNum - 1) * pageSize, pageSize);
    };

    this.createDataPostForIdsOnlyList = function () {
        var settings = $("#cr").dataTable().fnSettings();
        var dataObj = {filterMap: {}};

        dataObj.filterMap.entityIds = self.fetchIdsForPage(self.getIdsFromUrl(), settings._iDisplayLength, (Math.ceil((settings._iDisplayStart + 1) / settings._iDisplayLength)));
        dataObj.filterMap.filterJson = {};
        if (listJson.columnsGroup) {
            dataObj["selectedColumns"] = listJson.columnsGroup;
        }
        return JSON.stringify(dataObj);
    };

    this.getIdsFromUrl = function () {
        if ($.urlParam("type")) {
            var idsOnly = localStorage.getItem("todolistIds");
            return idsOnly.split(",").map(function (d) {
                return Number(d);
            });
        }
    };

    this.checkIfIdsOnlyListing = function () {
        if (localStorage.getItem("todolistIds")) {
            return true;
        } else {
            return false;
        }
    };

    this.lazyLoadAppStyles = function (url) {
        const getDynURL = () => {
            const resourceURL = url + uiAppVersion,
                dynURL = (!!cloudUrl ? cloudUrl : '') + resourceURL;
            return dynURL;
        };

        const styleElm = $("<link/>").attr({
            rel: 'stylesheet',
            href: getDynURL()
        });

        $("head").append(styleElm);
    };


    this.getParameterByName = function (name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    };

    this.highlightCurrentListing = function (data, _listID) {
        var X = _.findIndex(data, function (ob) {
            return ob.listId && ob.listId == _listID;
        });
        for (var i = 0; i < data.length; i++) {
            data[i]["isCurrentList"] = false;
        }
        if (X > -1 && data[X]) {
            /*if(! data[X]["isCurrentList"] ){
            data[X]["isCurrentList"] = false;
        }*/
            data[X]["isCurrentList"] = true;
        }

    }
    this.performViewOperation = function (id) {
        if (id) {
            var str2 = addtStamp("#/show/tblcontractdocuments/" + id);
            var relationId = sJq.$("#relationId").val();
            window.location = str2;
            $("#tiptip_holder").remove();
        }
    }

    this.appendSupportEmail = function (email) {
        if (email) {
            $(".supportText").show();
            $(".supportText").append(email);
            $(".supportText").find("a").addClass("supportEmailAtag");
        }
    }
    this.getRespectiveSirion1Hash = function (UX2_0_HASH) {
        var retval = UX2_0_HASH;
        if (UX2_0_HASH == "#/changePassword") {
            retval = addtStamp("changePasswordForm");
        }
        return retval;
    };
    this.checkColumnTypeBulkCheckBox = function (_colArray) {
        var retval = false;
        if (!_colArray) {
            return retval;
        }
        var colLen = _colArray.length;
        if (colLen != 1) {
            return retval;
        }
        if (_colArray[0] && _colArray[0].columnQueryName == "bulkcheckbox") {
            retval = true;
        }
        return retval;
    };
    this.getQueryParam = function (url) {
        var queryObj = {};
        if (url.split("?").length > 0) {
            var queryString = url.split("?")[1];
        }
        if (self.isEmpty(queryString)) {
            return;
        }
        queryObj = JSON.parse('{"' + queryString.replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
        return queryObj;
    };
    /** Coerce numeric listing id query values to integers for JSON payloads; keep "" when absent. */
    this.normalizeListingBulkIdValue = function (v) {
        if (v === null || v === undefined) {
            return "";
        }
        if (v === "") {
            return "";
        }
        if (typeof v === "number" && !isNaN(v)) {
            return v;
        }
        var t = String(v).trim();
        if (t === "") {
            return "";
        }
        if (/^-?\d+$/.test(t)) {
            return Number(t);
        }
        return v;
    };
    /** Contract / relation / vendor scope from list URL (?contractId=…&relationId=…&vendorId=…) for bulk APIs */
    this.getListingBulkContextParamsFromHash = function () {
        var hash = (window.location && window.location.hash) ? window.location.hash : "";
        var q = {};
        try {
            var parsed = self.getQueryParam(hash);
            if (parsed && typeof parsed === "object") {
                q = parsed;
            }
        } catch (e) {
            q = {};
        }
        var contractId = q.contractId != null ? String(q.contractId) : "";
        var relationId = q.relationId != null ? String(q.relationId) : "";
        var vendorId = q.vendorId != null ? String(q.vendorId) : "";
        if (!contractId && !relationId && !vendorId) {
            return null;
        }
        return {
            contractId: self.normalizeListingBulkIdValue(contractId),
            relationId: self.normalizeListingBulkIdValue(relationId),
            vendorId: self.normalizeListingBulkIdValue(vendorId)
        };
    };
    /**
     * Listing scope ids from the current hash only (#/...?contractId=&relationId=&vendorId=).
     * No $rootScope fallback — avoids attaching stale ids when the URL no longer carries them.
     */
    this.getListingBulkContextParamsWithRootFallback = function () {
        return self.getListingBulkContextParamsFromHash();
    };
    /** Lowercase query keys — kept for any legacy callers; prefer getBulkActionSaveListingQueryString for /bulkaction/save. */
    this.getListingBulkContextQueryString = function () {
        var ctx = self.getListingBulkContextParamsFromHash();
        if (!ctx) {
            return "";
        }
        function hasParam(v) {
            return v !== null && v !== undefined && v !== "";
        }
        var parts = [];
        if (hasParam(ctx.contractId)) {
            parts.push("contractId=" + encodeURIComponent(String(ctx.contractId)));
        }
        if (hasParam(ctx.relationId)) {
            parts.push("relationId=" + encodeURIComponent(String(ctx.relationId)));
        }
        if (hasParam(ctx.vendorId)) {
            parts.push("vendorId=" + encodeURIComponent(String(ctx.vendorId)));
        }
        return parts.length ? parts.join("&") : "";
    };
    /** Query string for /bulkaction/save only: ContractId, RelationId, VendorId (present values only). */
    this.getBulkActionSaveListingQueryString = function () {
        var ctx = self.getListingBulkContextParamsFromHash();
        if (!ctx) {
            return "";
        }
        function hasParam(v) {
            return v !== null && v !== undefined && v !== "";
        }
        var parts = [];
        if (hasParam(ctx.contractId)) {
            parts.push("ContractId=" + encodeURIComponent(String(ctx.contractId)));
        }
        if (hasParam(ctx.relationId)) {
            parts.push("RelationId=" + encodeURIComponent(String(ctx.relationId)));
        }
        if (hasParam(ctx.vendorId)) {
            parts.push("VendorId=" + encodeURIComponent(String(ctx.vendorId)));
        }
        return parts.length ? parts.join("&") : "";
    };
    this.appendListingBulkContextToBulkActionSaveUrl = function (url) {
        if (!url || typeof url !== "string" || url.indexOf("/bulkaction/save") === -1) {
            return url;
        }
        var qs = self.getBulkActionSaveListingQueryString();
        if (!qs) {
            return url;
        }
        return self.addQueryString(url, qs);
    };
    /**
     * Whether to merge listing contract/relation/vendor ids into POST JSON body (not used for /bulkaction/save — query only).
     */
    this.shouldMergeListingIdsIntoBulkPostPayload = function (url, data) {
        if (!url || typeof url !== "string") {
            return false;
        }
        var path = url.split("?")[0];
        if (path.indexOf("/bulkaction/save") > -1) {
            return false;
        }
        if (path.indexOf("/bulkAmendment/registerRequest") > -1) {
            return false;
        }
        /** Bulk edit submit — merge listing contract/relation/vendor into body even when `data` is form-shaped, not flat bulk. */
        if (/\/bulkedit\/(?:v2\/)?edit\//.test(path)) {
            return true;
        }
        /** Bulk edit create layout/submit — same listing + job-scheduler merge as edit. */
        if (/\/bulkedit\/(?:v2\/)?create\b/.test(path)) {
            return true;
        }
        var fragments = [
            "/slRawData/v2/generateBulkTemplate",
            "/commentAttachments/v2/generateBulkTemplate",
            "/bulk-revalidate/save",
            "/bulkupload/"
        ];
        for (var i = 0; i < fragments.length; i++) {
            if (path.indexOf(fragments[i]) > -1) {
                return true;
            }
        }
        if (data && typeof data === "object") {
            var likeBu = data.filterMap !== undefined && data.listId !== undefined &&
                (data.selectAll !== undefined || Array.isArray(data.entityIds));
            if (likeBu) {
                return true;
            }
        }
        return false;
    };
    /** True when $rootScope.fromJobSchedular is set (listing/bootstrap may only set this, not the hash). */
    this.isRootScopeFromJobSchedular = function (rs) {
        try {
            if (!rs && window.angular && document.body) {
                rs = window.angular.element(document.body).injector().get("$rootScope");
            }
            if (!rs || rs.fromJobSchedular == null || rs.fromJobSchedular === "") {
                return false;
            }
            var v = rs.fromJobSchedular;
            if (v === true || v === 1) {
                return true;
            }
            var s = String(v).toLowerCase().trim();
            return s === "true" || s === "1" || s === "yes";
        } catch (e) {
            return false;
        }
    };
    /**
     * Multi-step bulk/schedulers: browser URL is primary; $rootScope keeps canonical ids when hash changes before step 2.
     */
    this.mergeRootScopeJobSchedulerCanonicalIntoQuery = function (q) {
        if (!q || typeof q !== "object") {
            return;
        }
        try {
            if (!window.angular || !document.body) {
                return;
            }
            var rs = window.angular.element(document.body).injector().get("$rootScope");
            if (!rs) {
                return;
            }
            function ne(v) {
                return v !== null && v !== undefined && v !== "";
            }
            if (!q.requestId && ne(rs.jobSchedulerRequestId)) {
                q.requestId = rs.jobSchedulerRequestId;
            }
            if (!q.userTaskId && ne(rs.jobSchedulerUserTaskId)) {
                q.userTaskId = rs.jobSchedulerUserTaskId;
            }
            if ((q.type == null || q.type === "") && ne(rs.jobSchedulerType)) {
                q.type = rs.jobSchedulerType;
            }
            if ((q.fromJobSchedular == null || q.fromJobSchedular === "") && ne(rs.fromJobSchedular)) {
                q.fromJobSchedular = rs.fromJobSchedular;
            }
        } catch (e) {
        }
    };
    /** When the browser URL exposes scheduler params, mirror them to $rootScope for subsequent requests in the same session. */
    this.syncBrowserJobSchedulerCanonicalToRootScope = function (q) {
        if (!q || !q.requestId || !q.userTaskId) {
            return;
        }
        try {
            if (!window.angular || !document.body) {
                return;
            }
            var rs = window.angular.element(document.body).injector().get("$rootScope");
            if (!rs) {
                return;
            }
            rs.jobSchedulerRequestId = q.requestId;
            rs.jobSchedulerUserTaskId = q.userTaskId;
            if (q.type != null && q.type !== "") {
                rs.jobSchedulerType = q.type;
            }
            if (q.fromJobSchedular != null && q.fromJobSchedular !== "") {
                rs.fromJobSchedular = q.fromJobSchedular;
            }
        } catch (e2) {
        }
    };
    /** requestId, userTaskId, type, fromJobSchedular from listing hash (and $.urlParam fallback if present). */
    this.getJobSchedularParamsFromListingUrl = function () {
        var q = {};
        try {
            var hash = (window.location && window.location.hash) ? window.location.hash : "";
            var parsed = self.getQueryParam(hash);
            if (parsed && typeof parsed === "object") {
                q = parsed;
            }
        } catch (e1) {
            q = {};
        }
        try {
            if (typeof window.$ !== "undefined" && window.$.urlParam) {
                if (!q.requestId && $.urlParam("requestId")) {
                    q.requestId = $.urlParam("requestId");
                }
                if (!q.userTaskId && $.urlParam("userTaskId")) {
                    q.userTaskId = $.urlParam("userTaskId");
                }
                if (!q.type && $.urlParam("type")) {
                    q.type = $.urlParam("type");
                }
                if (q.fromJobSchedular == null && $.urlParam("fromJobSchedular")) {
                    q.fromJobSchedular = $.urlParam("fromJobSchedular");
                }
            }
        } catch (e2) {
        }
        /** Multi-step flows: URL first; then $rootScope canonical fields set when URL had scheduler params (survives hash change). */
        try {
            self.mergeRootScopeJobSchedulerCanonicalIntoQuery(q);
        } catch (eRsCanon) {
        }
        try {
            if (self._bulkJobSchedulerListingCtx && typeof self._bulkJobSchedulerListingCtx === "object") {
                var stMem = self._bulkJobSchedulerListingCtx;
                if (!q.requestId && stMem.requestId) {
                    q.requestId = stMem.requestId;
                }
                if (!q.userTaskId && stMem.userTaskId) {
                    q.userTaskId = stMem.userTaskId;
                }
                if (q.type == null || q.type === "") {
                    if (stMem.type != null && stMem.type !== "") {
                        q.type = stMem.type;
                    }
                }
                if (q.fromJobSchedular == null || q.fromJobSchedular === "") {
                    if (stMem.fromJobSchedular != null && stMem.fromJobSchedular !== "") {
                        q.fromJobSchedular = stMem.fromJobSchedular;
                    }
                }
            }
        } catch (e3) {
        }
        try {
            if ((q.fromJobSchedular == null || q.fromJobSchedular === "") && self.isRootScopeFromJobSchedular()) {
                q.fromJobSchedular = "true";
            }
        } catch (eRsQ) {
        }
        try {
            if (q.requestId && q.userTaskId) {
                self.syncBrowserJobSchedulerCanonicalToRootScope(q);
                self._bulkJobSchedulerListingCtx = {
                    requestId: String(q.requestId),
                    userTaskId: String(q.userTaskId)
                };
                if (q.type != null && q.type !== "") {
                    self._bulkJobSchedulerListingCtx.type = String(q.type);
                }
                if (q.fromJobSchedular != null && q.fromJobSchedular !== "") {
                    self._bulkJobSchedulerListingCtx.fromJobSchedular = q.fromJobSchedular;
                }
            }
        } catch (e4) {
        }
        return q;
    };
    this.isFromJobSchedularListingContext = function () {
        if (self.isRootScopeFromJobSchedular()) {
            return true;
        }
        var q = self.getJobSchedularParamsFromListingUrl();
        if (q.fromJobSchedular === "true" || q.fromJobSchedular === true) {
            return true;
        }
        var typeLc = q.type != null ? String(q.type).toLowerCase() : "";
        if (q.requestId && q.userTaskId && (typeLc === "success" || typeLc === "failure" || typeLc === "error")) {
            return true;
        }
        /** In-memory snapshot had requestId+userTaskId from listing; hash may be gone at bulk-edit submit. */
        try {
            if (q.requestId && q.userTaskId && self._bulkJobSchedulerListingCtx &&
                    String(self._bulkJobSchedulerListingCtx.requestId) === String(q.requestId) &&
                    String(self._bulkJobSchedulerListingCtx.userTaskId) === String(q.userTaskId)) {
                return true;
            }
        } catch (eStash) {
        }
        return false;
    };
    /** True when payload carries bulk selection (parallel to selectAll). */
    this.payloadLooksLikeBulkSelectionPayload = function (payload) {
        if (!payload || typeof payload !== "object") {
            return false;
        }
        if (payload.selectAll !== undefined || payload.isSelectAll !== undefined) {
            return true;
        }
        if (payload.filterMap !== undefined && payload.listId !== undefined) {
            return true;
        }
        if (payload.listId !== undefined && payload.entityIds !== undefined && payload.entityTypeId !== undefined) {
            return true;
        }
        return false;
    };
    this.shouldAttachJobSchedularBulkFields = function (payload) {
        if (!self.payloadLooksLikeBulkSelectionPayload(payload)) {
            return false;
        }
        var q = self.getJobSchedularParamsFromListingUrl();
        if (!q.requestId || !q.userTaskId) {
            return false;
        }
        if (self._bulkJobSchedulerConsumedRequestId != null &&
                String(self._bulkJobSchedulerConsumedRequestId) === String(q.requestId)) {
            return false;
        }
        if (self.isFromJobSchedularListingContext()) {
            return true;
        }
        /** Hash often cleared before submit; allow when select-all bulk matches in-memory snapshot taken when modal/list loaded. */
        if (payload.selectAll === true && self._bulkJobSchedulerListingCtx &&
                String(self._bulkJobSchedulerListingCtx.requestId) === String(q.requestId) &&
                String(self._bulkJobSchedulerListingCtx.userTaskId) === String(q.userTaskId)) {
            return true;
        }
        return false;
    };
    /** After a successful bulk action for this job-scheduler request, stop sending job fields until a new requestId appears. */
    this.markJobSchedularBulkPayloadConsumedForCurrentRequest = function () {
        var q = self.getJobSchedularParamsFromListingUrl();
        if (!q.requestId) {
            return;
        }
        self._bulkJobSchedulerConsumedRequestId = q.requestId;
    };
    /** Call after successful POST for bulk/job-scheduler flows so the next request omits job-scheduler payload keys. */
    this.markJobSchedularBulkPayloadConsumedIfPostSucceeded = function (url, resp) {
        if (!url || typeof url !== "string") {
            return;
        }
        var path = url.split("?")[0];
        /** Layout load only — must not consume scheduler ids; subsequent /bulkedit/.../edit still needs bulkEditRequestId, userTaskId, isSuccess. */
        if (/\/bulkedit\/(?:v2\/)?create\b/.test(path)) {
            return;
        }
        /** Matches bulk download v2 (template ± workflow), bulkedit create/edit, bulkaction/save, bulk-revalidate/save, bulkAmendment/registerRequest, slRawData & commentAttachments generateBulkTemplate. */
        var bulkFragments = [
            "/bulkedit/",
            "/bulkupload/",
            "/bulk-revalidate/",
            "/bulkAmendment/",
            "/slRawData/v2/generateBulkTemplate",
            "/commentAttachments/v2/generateBulkTemplate",
            "/bulkaction/save"
        ];
        var matches = false;
        for (var i = 0; i < bulkFragments.length; i++) {
            if (path.indexOf(bulkFragments[i]) > -1) {
                matches = true;
                break;
            }
        }
        if (!matches) {
            return;
        }
        if (resp && typeof resp === "object" && resp.header && resp.header.response &&
                resp.header.response.status === "applicationError") {
            return;
        }
        self.markJobSchedularBulkPayloadConsumedForCurrentRequest();
    };
    /**
     * Adds bulkEditRequestId, userTaskId, isSuccess when job-scheduler listing URL matches and bulk selection payload.
     */
    this.mergeJobSchedularBulkFieldsIntoPayload = function (payload) {
        if (!payload || typeof payload !== "object") {
            return;
        }
        if (!self.shouldAttachJobSchedularBulkFields(payload)) {
            return;
        }
        var q = self.getJobSchedularParamsFromListingUrl();
        var rid = parseInt(String(q.requestId), 10);
        var tid = parseInt(String(q.userTaskId), 10);
        if (!isNaN(rid)) {
            payload.bulkEditRequestId = rid;
        }
        if (!isNaN(tid)) {
            payload.userTaskId = tid;
        }
        payload.isSuccess = (String(q.type).toLowerCase() === "success");
    };
    /** Merge listing scope ids into a POST body (bulkupload download, etc.). Only sets keys that are non-empty. Also merges job-scheduler fields when applicable. */
    this.mergeListingBulkContextIntoPayload = function (payload) {
        if (!payload || typeof payload !== "object") {
            return;
        }
        /** One refresh for all bulk APIs that call this (bulkupload download, bulkedit create/edit, bulkaction body, bulk-revalidate, slRawData/commentAttachments templates, bulk amendment body, etc.). */
        try {
            self.getJobSchedularParamsFromListingUrl();
        } catch (eJobPrefetch) {
        }
        var ctx = self.getListingBulkContextParamsFromHash();
        if (ctx) {
            function hasParam(v) {
                return v !== null && v !== undefined && v !== "";
            }
            if (hasParam(ctx.contractId)) {
                payload.contractId = ctx.contractId;
            }
            if (hasParam(ctx.relationId)) {
                payload.relationId = ctx.relationId;
            }
            if (hasParam(ctx.vendorId)) {
                payload.vendorId = ctx.vendorId;
            }
        }
        self.mergeJobSchedularBulkFieldsIntoPayload(payload);
        self.mergeTodoListingFilterIntoBulkPayload(payload);
    };

    this.getTodoListingFilterMap = function () {
        try {          
            var inj = window.angular.element(document.body).injector();
            if (!inj) {
                return null;
            }
            var rs = inj.get("$rootScope");
            if (!rs || !rs.todoListFilter || typeof rs.todoListFilter !== "object") {
                return null;
            }
            /** Empty object means listing cleared it; treat as not-on-todo. */
            for (var anyKey in rs.todoListFilter) {
                if (Object.prototype.hasOwnProperty.call(rs.todoListFilter, anyKey)) {
                    return rs.todoListFilter;
                }
            }
            return null;
        } catch (eRs) {
            return null;
        }
    };

    this.mergeTodoListingFilterIntoBulkPayload = function (payload) {
        if (!payload || typeof payload !== "object") {
            return;
        }
        /** Only target bulk bodies (have filterMap, or entityIds/selectAll/listId/bulkUpdateRequestData indicators) so we don't pollute id-only objects like FormData scratch holders. */
        var looksLikeBulkBody = (payload.filterMap !== undefined && payload.filterMap !== null && typeof payload.filterMap === "object") ||
            payload.entityIds !== undefined ||
            payload.selectAll !== undefined ||
            payload.bulkUpdateRequestData !== undefined ||
            (payload.listId !== undefined && payload.listId !== null && payload.listId !== "");
        if (!looksLikeBulkBody) {
            return;
        }
        var listingFilterMap = self.getTodoListingFilterMap();
        if (!listingFilterMap) {
            return;
        }
        if (!payload.filterMap || typeof payload.filterMap !== "object") {
            payload.filterMap = {};
        }
        for (var k in listingFilterMap) {
            if (!Object.prototype.hasOwnProperty.call(listingFilterMap, k)) {
                continue;
            }
            if (payload.filterMap[k] !== undefined) {
                continue;
            }
            payload.filterMap[k] = listingFilterMap[k];
        }
        payload.filterMap.bypassPreferredView = true;
    };
    /** True when url is POST target for bulk edit (v1 or v2). Query string is ignored. */
    this.isBulkEditEditPostUrl = function (url) {
        if (!url || typeof url !== "string") {
            return false;
        }
        return /\/bulkedit\/(?:v2\/)?edit\//.test(url.split("?")[0]);
    };
    /**
     * Optional parent segments on edit URL, same order as create: …/edit/{entityTypeId}/{parentEntityTypeId}/{parentEntityId}
     * @returns {{ parentEntityTypeId: number, parentEntityId: number }|null}
     */
    this.getBulkEditParentEntityFromEditUrl = function (url) {
        if (!url || typeof url !== "string") {
            return null;
        }
        var pathPart = url.split("?")[0];
        var m = pathPart.match(/\/bulkedit\/(?:v2\/)?edit\/\d+(?:\/(\d+)\/(\d+))?\s*$/);
        if (!m || m[1] == null || m[2] == null || m[1] === "" || m[2] === "") {
            return null;
        }
        return {
            parentEntityTypeId: self.normalizeListingBulkIdValue(m[1]),
            parentEntityId: self.normalizeListingBulkIdValue(m[2])
        };
    };
    /**
     * Parent scope for nested list bulk edit (hash query only), optional path on edit URL, then stash from bulk create.
     * @param {string} [editUrl]
     * @param {{ skipStash?: boolean }} [opts] pass skipStash when persisting stash from bulk create open (avoid reading stale stash).
     * @returns {{ parentEntityTypeId: number, parentEntityId: number|string }}|null
     */
    this.getBulkEditParentEntityContextFromListing = function (editUrl, opts) {
        opts = opts || {};
        var ctx = self.getListingBulkContextParamsFromHash();
        if (ctx) {
            if (ctx.contractId !== "" && ctx.contractId != null) {
                return { parentEntityTypeId: 61, parentEntityId: ctx.contractId };
            }
            if (ctx.relationId !== "" && ctx.relationId != null) {
                return { parentEntityTypeId: 1, parentEntityId: ctx.relationId };
            }
            if (ctx.vendorId !== "" && ctx.vendorId != null) {
                return { parentEntityTypeId: 3, parentEntityId: ctx.vendorId };
            }
        }
        if (editUrl) {
            var fromPath = self.getBulkEditParentEntityFromEditUrl(editUrl);
            if (fromPath) {
                return fromPath;
            }
        }
        if (!opts.skipStash) {
            try {
                if (window.angular && document.body) {
                    var inj = window.angular.element(document.body).injector();
                    if (inj) {
                        var rs = inj.get("$rootScope");
                        var st = rs.bulkEditSubmitParentEntity;
                        if (st && st.parentEntityTypeId != null && st.parentEntityId != null && st.parentEntityId !== "") {
                            return {
                                parentEntityTypeId: st.parentEntityTypeId,
                                parentEntityId: st.parentEntityId
                            };
                        }
                    }
                }
            } catch (e2) {
            }
        }
        return null;
    };
    this.capitalizeText = function (str, ordiance) {
        str = str.toLowerCase();
        var array = str.split(' ');
        var n = !self.isEmpty(ordiance) ? (ordiance) : array.length;
        for (var c = 0; c < n; c++) {
            array[c] = array[c][0].toUpperCase() + array[c].substring(1);
        }
        return array.join(' ');
    };
    this.validateNumber = function (_phoneNo) {
        /*SIR-199155*/
        var pattern = /^\d+$/;
        return pattern.test(_phoneNo);
    }
    this.openInNewTab = function (url, _target) {
        window.open(url, _target);
    };

    this.addQueryString = function (url, queryString, queryParam) {
        var isQuestionMarkPresent = url && url.indexOf('?') !== -1,
            separator = '';

        if (queryParam && url.indexOf(queryParam) !== -1 ){
            // Extract the value from queryString
            var valueMatch = queryString.match(new RegExp(queryParam + "=([^&]*)"));
            var value = valueMatch ? valueMatch[1] : "";

            // Update the existing parameter in the URL
            var re = new RegExp("([?&])" + queryParam + "=.*?(&|$)", "i");
            url = url.replace(re, '$1' + queryParam + "=" + value + '$2');
            return url;
        } else {
            if (queryString) {
                separator = isQuestionMarkPresent ? '&' : '?';
                url += separator + queryString;
            }
        }

        return url;
    };
    /*  takes comma separated values as args and retrun JSON array of the form
*   [{"id":"","name":""}]
*   */
    this.makeJsonArrayFromIds = function (IDS) {
        if (self.isEmpty(IDS)) {
            return [];
        }
        if (!SirionUtils.isArray(IDS) && typeof IDS == "string") {
            IDS = JSON.parse(IDS)
        }
        var ratArray = [];
        for (var i = 0; i < IDS.length; i++) {
            ratArray[i] = {"id": IDS[i]/*,"name":""*/};
        }
        return ratArray;
    };

    this.updateFilterJsonMap = function (mapObject, id, filterName, selectedData) {
        // Params : Filter Object:Object, Filter Id:Integer, Filter Name: String, Selected Data: Array
        mapObject[id] = {
            "entityFieldHtmlType": NaN,
            "entityFieldId": NaN,
            "filterId": id,
            "filterName": filterName,
            "multiselectValues": {
                "SELECTEDDATA": selectedData
            }
        };
        return mapObject;
    }

    this.updateQueryStringParameter = function (uri, key, value) {
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf('?') !== -1 ? "&" : "?";
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        } else {
            return uri + separator + key + "=" + value;
        }
    };
    this.removeURLParameter = function (url, parameter) {
        //prefer to use l.search if you have a location/link object
        var urlparts = url.split('?');
        if (urlparts.length >= 2) {

            var prefix = encodeURIComponent(parameter) + '=';
            var pars = urlparts[1].split(/[&;]/g);

            //reverse iteration as may be destructive
            for (var i = pars.length; i-- > 0;) {
                //idiom for string.startsWith
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }

            return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
        }
        return url;
    }
    this.removeMultipleURLParameters = function (url, parameters) {
        // Split the URL into parts at the question mark
        const urlparts = url.split('?');
        if (urlparts.length >= 2) {

            // Map each parameter to its encoded format with '='
            const prefixes = parameters.map(param => encodeURIComponent(param) + '=');
            let pars = urlparts[1].split(/[&;]/g);

            // Remove any parameters that start with one of the prefixes
            pars = pars.filter(par => !prefixes.some(prefix => par.startsWith(prefix)));

            // Reconstruct the URL without the removed parameters
            return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
        }
        return url;
    }
    this.addEntityIdsFilter = function (obj, _query) {
        if (_query && _query["filterEntityIds"] == "true" && localStorage
            && (localStorage.getItem("successEntities") || localStorage.getItem("failedEntities"))) {
            obj = {"filterMap": {"filterJson": {}}};
            var IDS = JSON.parse(localStorage.getItem("successEntities")) ? localStorage.getItem("successEntities") : JSON.parse(localStorage.getItem("failedEntities"));
            var _jsonArray = self.makeJsonArrayFromIds(IDS);
            if (!self.isEmpty(_jsonArray)) {
                obj.filterMap.filterJson = self.updateFilterJsonMap(obj.filterMap.filterJson, "362", "filterEntityIds", _jsonArray);
            }
        }
        return obj;
    };
    this.appendJobDetails = function (url, OBJ) {
        var API_URL = url;
        var currentJob = this.getjobDetailObject();
        if (currentJob) {
            var BULK_REQ_ID = currentJob["bulkRequestId"];
            var SUC_FLAG = currentJob["isSuccess"];
            API_URL = SirionUtils.addQueryString(API_URL, 'bulkRequestId=' + BULK_REQ_ID);
            API_URL = SirionUtils.addQueryString(API_URL, 'isSuccess=' + SUC_FLAG);
            if(currentJob["jobId"]){
                API_URL = SirionUtils.addQueryString(API_URL, 'jobId=' + currentJob["jobId"]);
            }
        }
        return API_URL;
    };

    this.getjobDetailObject = function () {
        var currentJob = null;
        if (typeof $ != "undefined" && typeof $.urlParam == "function") {
            var requestId = $.urlParam("requestId");
            var type = $.urlParam("type");
            if (requestId && type) {
                try {
                    var jobDetail = JSON.parse(localStorage.getItem("jobDetails"));
                    currentJob = jobDetail[requestId] && jobDetail[requestId][type];
                } catch (e) {
                    console.log(e);
                }
            }
        }
        return currentJob;
    }


    this.setUpCommonPicker = function (name, val, isMinDateToday, isOpened) {
        var sc = this;
        if (!sc.commonDatepicker) {
            sc.commonDatepicker = {
                opened: {},
                datepickerOptions: {},
                value: {},
                buttonBaroptions: {
                    show: true,
                    now: {
                        show: false,
                        text: 'Now',
                        cls: 'btn-sm btn-default'
                    },
                    today: {
                        show: true,
                        text: 'Today',
                        cls: 'btn-sm btn-default'
                    },
                    clear: {
                        show: true,
                        text: 'Clear',
                        cls: 'btn-sm btn-default'
                    },
                    date: {
                        show: false,
                        text: 'Date',
                        cls: 'btn-sm btn-default'
                    },
                    time: {
                        show: false,
                        text: 'Time',
                        cls: 'btn-sm btn-default'
                    },
                    close: {
                        show: true,
                        text: 'Done',
                        cls: 'btn-sm btn-default'
                    },
                    cancel: {
                        show: false,
                        text: 'Cancel',
                        cls: 'btn-sm btn-default'
                    }
                }
            }
        }
        if (!sc.commonDatepicker.datepickerOptions[name]) {
            sc.commonDatepicker.datepickerOptions[name] = {showWeeks: false};
            if (isMinDateToday) {
                sc.commonDatepicker.datepickerOptions[name]["minDate"] = new Date();
            }
            sc.commonDatepicker.value[name] = val ? val : null;
            sc.commonDatepicker.opened[name] = isOpened ? isOpened : false;
        }
    };
    this.isPageVisited = function (page) {
        var visitedPages = window.localStorage.getItem("visitedPages"),
            bool = false;
        if (visitedPages) {
            var obj = JSON.parse(visitedPages);
            bool = obj[page] ? true : false
        }
        return bool;
    }

    this.setPageVisited = function (page, bool) {
        var visitedPages = window.localStorage.getItem("visitedPages") || "{}";
        var obj = JSON.parse(visitedPages);
        obj[page] = bool;
        window.localStorage.setItem("visitedPages", JSON.stringify(obj));
    }
    /*
* Convert "{"X","Y"}" to  [X, Y]
* */
    this.getFlatArrayFromObject = function (_rowData) {
        var retVal = [];
        if (SirionUtils.isEmpty(_rowData)) {
            return retVal;
        }
        for (var key in _rowData) {
            if (_rowData.hasOwnProperty(key)) {
                if (_rowData[key].columnName == "document_tag_ids") {
                    if (!SirionUtils.isEmpty(_rowData[key].value)) {
                        var X = _rowData[key].value;
                        retVal = X.replace(/{/g, '').replace(/}/g, '').split(",").map(function (item) {
                            return parseInt(item, 10);
                        });
                    }
                }
            }
        }
        return retVal;
    };

    /*
* Convert 1:;276571:;true to  276571
* */
    this.getFileID = function (_rowData) {
        var retVal = "";
        if (SirionUtils.isEmpty(_rowData)) {
            return retVal;
        }
        for (var key in _rowData) {
            if (_rowData.hasOwnProperty(key)) {
                if (_rowData[key].columnName == "documentstatus") {
                    if (!SirionUtils.isEmpty(_rowData[key].value)) {
                        var X = _rowData[key].value;
                        retVal = parseInt(X.split(":;")[1]);
                    }
                }
            }
        }
        return retVal;
    };
    this.convertStrArrToInt = function (Array) {
        if (SirionUtils.isEmpty(Array)) {
            return [];
        }
        return Array.map(function (item) {
            return parseInt(item, 10);
        });
    };

    this.fetchDocTagIDs = function (item) {
        var arr = [];
        $(item).find($('#fileProperties li.doc_tag_li')).each(function (i, li) {
            if ($(this).data('option-id') != undefined && $(this).find("input").is(":checked")) {
                if (arr.indexOf($(this).data('option-id')) == -1) {
                    arr.push($(this).data('option-id'));
                }
            }
        });
        return arr;
    }

    this.rmCollectionBlankArrayEntries = function (collection, node) {
        if (SirionUtils.isArray(collection[node]) && SirionUtils.isEmpty(collection[node])) {
            delete collection[node];
        }
        return collection;
    }

    this.checkForDocTagPermission = function (layoutData) {
        var retval = false;
        if (SirionUtils.isEmpty(layoutData)) {
            return retval;
        }
        layoutData.fields.forEach(function (field, index) {
            if (field.name == "COMMUNICATION" || field.type == "communicationTab" || field.id == 4006) {
                field.fields.forEach(function (childField, index) {
                    if (childField && childField.properties && childField.properties.documentTags == true) {
                        childField.fields.forEach(function (grandChildField, index) {
                            if (grandChildField.name == "documentTags") {
                                retval = true;
                            }
                        });
                    } else {
                        return retval;
                    }
                });
            }
        });
        return retval;
    };
    this.keyDownSearchListUtility = function (e) {
        var keyCode = window.event ? e.keyCode : e.which;
        //UP
        if (keyCode == 38) {
            $('html, body').animate({scrollTop: 0}, 1000);
            return false;
        }
        //DOWN
        if (keyCode == 40) {
            $('html, body').animate({scrollTop: $(document).height()}, 1000);
            return false;
        }
    };
    /* Validate Report Filters.*/
    this.validateMadetoryFilters = function (jsonObj) {
        var validationMessage = "";
        var jsonObj = {};
        if (SirionUtils.isEmpty(jsonObj)) {
            var json = stringify_datatable_json(true).replace(/'/g, "");
            jsonObj = $.parseJSON(json);
        }

        let contractMandatoryCheck = false;
        $.each(jsonObj.filterMap.filterJson, function (index, value) {
            if (value.filterName == "contractInfo") {
                contractMandatoryCheck = true;
                if (value.multiselectValues.SELECTEDDATA.length && value.multiselectValues.SELECTEDDATA[0].id == "") {
                    validationMessage = intl_msg[29294] || 'Please select a contract';
                }
            } else if (value.filterName == "dataFormat") {
                var changeReq = jsonObj.filterMap.filterJson["369"];
                var dataFormat = value.multiselectValues.SINGLESELECT;
                if (value.multiselectValues.SELECTEDDATA.length && value.multiselectValues.SELECTEDDATA[0].id == "" && changeReq) {
                    if (changeReq.multiselectValues.SELECTEDDATA &&
                        changeReq.multiselectValues.SELECTEDDATA.length && changeReq.multiselectValues.SELECTEDDATA[0].id != ""
                        && changeReq.multiselectValues.SELECTEDDATA[0].id > 0) {
                        validationMessage = intl_msg[29304] || 'Please select data format';
                    }
                }
            }
        });
        if (!contractMandatoryCheck) {
            validationMessage = intl_msg[29294] || 'Please select a contract';
        }
        return validationMessage;
    };


    this.getExtension = function (name) {
        if (name) {
            var nameArr = name.split(".");
            if (nameArr.length < 2) {
                return null;
            } else {
                return nameArr[nameArr.length - 1].toLowerCase();
            }
        }
        return null;
    }

    this.validateEntityId = function (ENTITY_ID) {
        var retval = true;
        var numbers = /^[0-9]+$/;
        if (!ENTITY_ID.match(numbers)) {
            retval = false;
        }
        return retval;
    };

    this.navigateTo = function (href, newTab) {
        var a = document.createElement('a');
        a.href = href;
        if (newTab) {
            a.setAttribute('target', '_blank');
        }
        a.click();
    }

    this.updateClassificationLabels = function (_classificationList, _rootScope) {
        if (_classificationList && _classificationList.length > 0) {
            angular.forEach(_classificationList, function (obj) {
                if (obj.name == "Legal") {
                    obj.val = intl_msg[4567];
                } else if (obj.name == "Financial") {
                    obj.val = intl_msg[4566];
                } else if (obj.name == "BusinessCase") {
                    obj.val = intl_msg[4568];
                }
            });
        }
        return _classificationList;
    };
    /*  ContractDocument Row-Selected Model  */
    this.prepareSelectedModel = function (_rowData, metadata, _scope, format) {
        var retval = {"data": {}, "permissions": {}};
        var MASTER_LIST = {
            "templateTypeList": metadata.draftMetadata.templateTypeList,
            "classification": metadata.draftMetadata.classification,
            "documentStatus": metadata.draftMetadata.documentStatus
        };
        if (SirionUtils.isEmpty(_rowData)) {
            return retVal;
        }
        let docExtension;
        const handleYesNoValues = ({_rowData,key,valueToCheck,keyToSet}) => {
            if (!SirionUtils.isEmpty(_rowData[key].value)) {
                var X = _rowData[key].value;
                var flag = false;
                if (X.toLowerCase().includes(valueToCheck)) {
                    flag = true;
                }
                retval["data"][keyToSet] = flag;
            }
        }
        for (var key in _rowData) {
            if (_rowData.hasOwnProperty(key)) {
                if(_rowData[key].columnName == "documentname") {
                    const splitArr = (_rowData[key].value || '').split(':;');
                    docExtension = splitArr?.[2];
                    retval["data"]["docExt"] = docExtension;
                }else if (_rowData[key].columnName == "document_tag_ids") {
                    retval.data["document_tag"] = [];
                    if (!SirionUtils.isEmpty(_rowData[key].value)) {
                        var X = _rowData[key].value;
                        var array = [];
                        array = X.replace(/{/g, '').replace(/}/g, '').split(",").map(function (item) {
                            return parseInt(item, 10);
                        });
                        array.forEach(function (elem) {
                            retval["data"]["document_tag"].push({"id": elem});
                        });
                    }
                } else if (_rowData[key].columnName == "classification") {
                    retval.data["classification"] = [];
                    if (!SirionUtils.isEmpty(_rowData[key].value)) {
                        var X = _rowData[key].value;
                        var valArr = X.split(":;"), fieldObj = {};
                        valArr.forEach(function (elem) {
                            if (elem.indexOf(",") > -1) {
                                var splitElem = elem.split(",");
                                splitElem.forEach(function (innerElem) {
                                    var splitIn = innerElem.split(":");
                                    fieldObj[splitIn[0]] = splitIn[1];
                                });
                            } else {
                                var splitElem = elem.split(":");
                                fieldObj[splitElem[0]] = splitElem[1];
                            }
                        });
                        if (fieldObj['financial'] == "true") {
                            retval["data"]["classification"].push({
                                "id": MASTER_LIST["classification"][1]["id"],
                                "name": MASTER_LIST["classification"][1]["name"],
                                "val": intl_msg[4566]
                            });
                        }
                        if (fieldObj['legal'] == "true") {
                            retval["data"]["classification"].push({
                                "id": MASTER_LIST["classification"][0]["id"],
                                "name": MASTER_LIST["classification"][0]["name"],
                                "val": intl_msg[4567]
                            });
                        }
                        if (fieldObj['businessCase'] == "true") {
                            retval["data"]["classification"].push({
                                "id": MASTER_LIST["classification"][2]["id"],
                                "name": MASTER_LIST["classification"][2]["name" +
                                ""],
                                "val": intl_msg[4568]
                            });
                        }
                        MASTER_LIST.classification = SirionUtils.updateClassificationOptions(MASTER_LIST.classification, fieldObj);
                    }
                } else if (_rowData[key].columnName == "documentstatus") {
                    retval.data["documentstatus"] = [];
                    if (!SirionUtils.isEmpty(_rowData[key].value)) {
                        var X = _rowData[key].value;
                        var splitArr = X.split(":;");
                        MASTER_LIST["documentStatus"].forEach(function (elem, index) {
                            if (!format.readOnly && splitArr[0] == elem.id) {
                                retval["data"]["documentstatus"].push({"id": elem.id, "name": elem.name});
                                retval["permissions"]["documentstatus"] = splitArr[2] == "true";
                                if (elem.id == 5 || elem.id == 7) {
                                    retval["permissions"]["documentstatus"] = false;
                                }
                            }
                        });
                    }
                } else if (_rowData[key].columnName == "sharewithsupplierflag") {
                    handleYesNoValues({_rowData,key,valueToCheck:'yes',keyToSet:'sharewithsupplierflag'});
                } else if (_rowData[key].columnName == "triggerautoextraction") {
                    handleYesNoValues({_rowData,key,valueToCheck:'yes',keyToSet:'triggerAutoExtraction'});
                } else if (_rowData[key].columnName == "type") {
                    retval.data["type"] = [];
                    if (!SirionUtils.isEmpty(_rowData[key].value)) {
                        var X = _rowData[key].value;
                        MASTER_LIST["templateTypeList"].forEach(function (elem, index) {
                            if (elem.name === X) {
                                retval["data"]["type"].push({"id": elem.id, "name": elem.name});
                                if (elem.id == 900) {
                                    retval["permissions"]["type"] = false;
                                }
                            }
                        });
                    }
                } else if (_rowData[key].columnName == 'docversionhidden') {
                    var hiddenCellData = _rowData[key].value.split(":;");
                    if (hiddenCellData[2] == "false") {
                        retval.permissions["documentstatus"] = false;
                        retval.permissions["type"] = false;
                        retval.permissions["sharewithsupplierflag"] = false;
                        retval.permissions["document_tag"] = false;
                        retval.permissions["triggerDeviation"] = false;
                    }
                } else if (_rowData[key].columnName == 'locked_status') {
                    var lockedData = _rowData[key].value;
                    if (!SirionUtils.isEmpty(lockedData)) {
                        var lockedSplit = lockedData.split(":;");
                        if (lockedSplit[0] == "true") {
                            retval.permissions["documentstatus"] = false;
                        }
                    }
                } else if (_rowData[key].columnName == "triggerdeviation") {
                    handleYesNoValues({_rowData,key,valueToCheck:'yes',keyToSet:'triggerDeviation'});
                }else if (_rowData[key].columnName == "autoredlinedocument") {
                    // Need To change this
                    retval["data"]["showAutoRedlineDocument"] = ['doc','docx'].includes(docExtension);
                    handleYesNoValues({_rowData,key,valueToCheck:'yes',keyToSet:'autoRedlineDocument'});
                }else if(_rowData[key].columnName == "file_external_id"){
                    retval["data"]["externalId"] = _rowData[key].value;
                }
            }
        }
        retval.masterDataClassification = MASTER_LIST.classification;
        return retval;
    };

    this.validIDFieldcheck = function ({ id, type }) {
        const validations = {
            'externalId': { allowedLength: 40, allowedSpecialChars: [ '_', '-', '@'] }
        }
        return id.length <= validations[type].allowedLength && (id == "" || SirionUtils.alphaNumericCheck(id, validations[type].allowedSpecialChars));
    };

    this.updateClassificationOptions = function (classificationList, fieldObj) {
        var fieldArr = {'Financial': 'userFinancial', 'Legal': 'userLegal', 'BusinessCase': 'userBusinessCase'}
        return classificationList.filter(function (obj) {
            return fieldObj[fieldArr[obj.name]] == "true"
        })
    }

    this.filterDocStatus = function (input, selectedRow, templateId) {
        var output = [];
        // if (self.isEmpty(selectedRow) || isNaN(selectedRow.id)) {
        //     output = input;
        // }else {
        angular.forEach(input, function (item) {
            if (!selectedRow || selectedRow.id == "" || selectedRow.id == 0) {
                // Show Final and Executed options
                if (item.id == 2 || item.id == 3) {
                    output.push({"id": item.id, "name": item.name});
                }
            } else if (selectedRow.id == 1) {
                // Show Final option
                if (item.id == 2) {
                    output.push(selectedRow);
                    output.push({"id": item.id, "name": item.name});
                }
            } else if (selectedRow.id == 2) {
                // Show Draft option
                if (item.id == 1 && templateId != 900) {
                    output.push(selectedRow);
                    output.push({"id": item.id, "name": item.name});
                } else if (item.id == 6 && templateId == 900) {
                    output.push(selectedRow);
                    output.push({"id": item.id, "name": item.name});
                }
            } else if (selectedRow.id == 3) {
                // Show Discarded option
                if (item.id == 4) {
                    output.push(selectedRow);
                    output.push({"id": item.id, "name": item.name});
                }
            } else if (selectedRow.id == 4) {
                if (item.id == 4) {
                    output.push(selectedRow);
                }
            } else if (selectedRow.id == 6) {
                if (item.id == 2) {
                    if (output.indexOf(selectedRow) == -1) {
                        output.push(selectedRow);
                    }
                    output.push({"id": item.id, "name": item.name});
                }
            }
        });
        // }
        return output;
    };

    this.customIndexOf = function (arrayLike, searchElement) {
        var object = Object(arrayLike);
        var length = object.length;
        var fromIndex = arguments.length > 2 ? arguments[2] > 0 : 0;
        if (length < 1 || typeof searchElement !== 'string' || fromIndex >= length) {
            return -1;
        }
        if (fromIndex < 0) {
            fromIndex = Math.max(length - Math.abs(fromIndex), 0);
        }
        var search = searchElement.toLowerCase();
        for (var index = fromIndex; index < length; index += 1) {
            if (index in object) {
                var item = object[index];
                if (typeof item === 'string' && search === item.toLowerCase()) {
                    return index;
                }
            }
        }
        return -1;
    };
    this.iterateTableData = function (dataObj, colName) {
        for (var key in dataObj) {
            if (dataObj.hasOwnProperty(key)) {
                if (dataObj[key].columnName === colName) {
                    return dataObj[key].value;
                }
            }
        }
        return "";
    };

    this.dropDownForMoreOptionIn_CDR = function (val, metadata, format, docId, docFileId, deleteTag, viewDetailsTag, editTagCopy, docStatusValue, isEnableSingleEdit, renameDocTag, isDocLocked) {
        var enableDelete = this.iterateTableData(val, "enable_delete_comment");
        var docIsLocked = isDocLocked && isDocLocked.split(":;")[0] === "true";
        var moreIcon = '<span id="infoButton" title="'+ intl_msg[31936]  + '" class=\"icon-more hover-icon' + '"' + `click-outside="clickOnMoreIconIn_CDR(event,false); "  outside-if-not=".click-status" onclick="$(this).scope().clickOnMoreIconIn_CDR(event,true,${docStatusValue.split(":;")[0]},${docFileId}, ${docStatusValue.split(":;")[2]}, ${docIsLocked})">`;
        var statusUpdateTag = isEnableSingleEdit ? ('<ul class="update_status">' + '<li class="click-status" title="' + (intl_msg[48156] || "Update Status to") + '" onclick="$(this).scope().clickSubDropdown_moreOption(event,' + docStatusValue.split(":;")[0] + ',' + docFileId + ')">' + (intl_msg[48156] || "Update Status to") + '<span class="icon-down-arrow "></span></li>' + '</ul>') : null;
        const tags = `${moreIcon}<div class='hidden More_option_dropDown container-drop-down moreOption-${docId}'>${statusUpdateTag || ""}${viewDetailsTag}${renameDocTag}${editTagCopy}${deleteTag}</div>`;


        if(!!statusUpdateTag || !!viewDetailsTag || !!editTagCopy || !!deleteTag || !!renameDocTag){
            return tags;
        }
        return '';
    }

    this.addDownloadDocOptions = function (val, metadata, format) {
        const downloadToolTipText = intl_msg[24209] || "Download";
        function getFileExt() {
            if (fileExtval == 'img')
                return 'png';

            return fileExtval;
        }

        var res = '<span class="icon-download hover-icon" title="'+downloadToolTipText+'" id="downloadDoc" onclick="$(this).scope().downloadDocClick(event)">';
        var tagAllw = metadata && metadata.draftMetadata && metadata.draftMetadata.taggedDocumentAllowed;
        let autoRedlineValue,autoRedlineDocumentStatus,autoRedlineLink='';
        var tagColval = null;
        var namColval = null;
        var fileExtval = null;
        var fileName = null;
        var id = null;
        var numArr = null;
        var documentStatus = null;
        var colValforNullTagged = null;
        const pdfDownloadEX = metadata.draftMetadata.extentionAllowedForPDFDownload;
        for (var key in val) {
            if (val[key].columnName == "tagged_document") {
                tagColval = val[key].value;
            }
            if (val[key].columnName == "documentname") {
                namColval = val[key].value ? (val[key].value.split(":;")[1] + "." + val[key].value.split(":;")[2]) : "";
                fileExtval = val[key].value.split(":;")[2];
                fileName = val[key].value ? _.escape(val[key].value.split(":;")[1]) : "";
                colValforNullTagged = val[key].value ? (val[key].value.split(":;")[4] + ":;" + val[key].value.split(":;")[3]) : "";
                id = val[key].value?val[key].value.split(":;")[0]:"";
            }
            if (val[key].columnName == "documentstatus") {
                documentStatus = val[key].value ? _.get(val[key], 'value').split(':;')[0] : '';
            }
            if(val[key].columnName == "autoredlinedocument"){
                autoRedlineValue = (val[key].value || '').toLowerCase().includes('yes');
            }
            if(val[key].columnName == "autoredlinedocumentstatus"){
                autoRedlineDocumentStatus = val[key].value;
            }
        }
        const autoRedlineAllowed = metadata && metadata.draftMetadata && metadata.draftMetadata.autoRedLineDocument && autoRedlineDocumentStatus == 3;
        const orignalDocIsPdf = (fileExtval || '').toLowerCase() === "pdf";
        var pdfDownAllw = (pdfDownloadEX.indexOf(fileExtval) > -1);
        var taggedDownLink = "";
        var PdfDownTag = "";
        var finalizedDocumentTag = "";
        if (tagColval && tagAllw) {
            let extension = 'docx';
            if(val[key].columnName == 'extension' && VALIDEXTENSIONS?.indexOf(val[key].value) == -1){
                extension = val[key].value;
            }
            numArr = tagColval.split(":;");
            lnk = "/editor/document/download/taggeddocument/" + numArr[0] + "/" + numArr[1];
            lnk = window.addtStamp(lnk);
            taggedDownLink = "<a id='downloadLink' onclick='$(this).scope().downloadDocClick(event, \"" + lnk + "\")' title='" + intl_msg[29574] + "'><i class=\"icon-" + extension + "\"></i>" + intl_msg[29574] + "</a>";
        }
        if(pdfDownAllw) {
            numArr = colValforNullTagged.split(":;");
            let fileObj = JSON.stringify({entityTypeId: colValforNullTagged.split(":;")[1], documentId: colValforNullTagged.split(":;")[0], fileString: 'DRAFT_PDF_DOCUMENTS', downloadLink:'', fileName: `${fileName}.pdf`, id, fileExtval});
            PdfDownTag =  "<a id='downloadLink' title='"+(intl_msg[33553] || 'PDF Document')+"'"+ `onclick='$(this).scope().downloadPDF(event,"${numArr}",${fileObj})'`+"><i class=\"icon-pdf \" ></i>"+(intl_msg[33553] || 'PDF Document')+"</a>"
        }
        if(['doc', 'docx'].includes(fileExtval) && metadata.entityTypeId === 160 ){
            finaliLink = window.addtStamp( "/download/draft/cleandocument/"+colValforNullTagged.split(":;")[0]+"/"+colValforNullTagged.split(":;")[1]);
            // let fileObj = JSON.stringify({entityTypeId: colValforNullTagged.split(":;")[1], documentId: colValforNullTagged.split(":;")[0], fileString: 'DRAFT_FINAL_DOCUMENTS', downloadLink: finaliLink, fileName: `${fileName}.${fileExtval}`, id, fileExtval});
            finalizedDocumentTag = "<a id='downloadLink'" + `onclick='$(this).scope().downloadDocClick(event,"${finaliLink}")'`+ "title='"+(intl_msg[33554] || 'Final Document')+"'><i class=\"icon-docx \"></i>" + (intl_msg[33554] || 'Final Document') + "</a>";
        }
        if(autoRedlineValue && autoRedlineAllowed) {
            numArr = colValforNullTagged.split(":;");
            const entityId = this.getEntityIdFromUrl();
            const label = intl_msg[35135] || "Auto Redlined Document";
            const lnk = `/mlRedlining/download/modified/${entityId}/${numArr[1]}/${numArr[0]}`;
            autoRedlineLink = "<a id='downloadLink' onclick='$(this).scope().downloadDocClick(event, \"" + lnk + "\")' title='" + label + "'><i class=\"icon-docx\"></i>"+ label + "</a>";
        }
        if(pdfDownAllw || !!taggedDownLink || orignalDocIsPdf || autoRedlineLink) {
            let fileString = '';
            if(!['docx','dox','doc'].includes(fileExtval)) {
                fileString = 'DRAFT_NON_WORD_DOCUMENTS';
            }
            let fileObj = JSON.stringify({entityTypeId: colValforNullTagged.split(":;")[1], documentId: colValforNullTagged.split(":;")[0],downloadLink:'', fileString, fileName: `${fileName}.${fileExtval}`, id, fileExtval});
            res += "<div class='hidden dropDown download container-drop-down'>" +
                "<a id='downloadLink'" + `onclick = '$(this).scope().downloadDocClick(event,null,${fileObj})'` + "title='" + (intl_msg[33552] || 'Original Document') + "'><i class='icon-" + getFileExt() + "'></i>" + (intl_msg[33552] || 'Original Document') + "</a>" +
                `${PdfDownTag}${finalizedDocumentTag}${taggedDownLink}${autoRedlineLink}`+
                "</div>";
        }
        res += "</span>"
        return res;
    }

    this.getValueFromDisplayFormat = function (format, valToFind) {
        var res = null;
        if (format) {
            try {
                var formatJson = JSON.parse(format);
                if (_.has(formatJson, valToFind)) {
                    res = formatJson[valToFind]
                }
            } catch (err) {
                console.log(err);
            }
        }
        return res;
    };

    this.getMultipleSuppliers = function (value, format, delimitter, limit) {
        var arr = [];
        if (!delimitter)
            arr = value.split("::");
        else
            arr = value.split(delimitter);
        var rootScope = $("#data-ng-app").scope();
        var privateFn = {
            getLink: function (obj, index) {
                var objArr = obj.split(":;");
                var url;
                if (format)
                    url = rootScope.urlFactory.getFormPageUrl("show", NumToURLPartMapping[format.entityTypeId], objArr[1]);
                else
                    url = "#/show/tblrelations/" + objArr[1];
                var link = $('<a></a>').attr({
                    href: addtStamp(url),
                    title: objArr[0],
                    class: index >= limit ? "moreThanLimit" : ""
                }).html(objArr[0]);
                return link;
            },
            getSeparator: function (index) {
                return $("<span>").attr({
                    class: index >= limit ? "moreThanLimit" : ""
                }).html(index ? "," : "");
            }
        }
        var valArr = arr.reduce(function (acc, obj, index) {
            var link = privateFn.getLink(obj, index);
            if (index) {
                acc = acc.append(privateFn.getSeparator(index));
            }
            acc = acc.append(link);

            if (index + 1 == arr.length && index >= limit) {
                var lessBtn = $('<a class="minBtn">, ...less</a>'),
                    moreBtn = $('<a class="maxBtn"></a>').html(",  ..." + (arr.length - limit) + " More");
                acc = acc.append(lessBtn).append(moreBtn);
            }
            return acc;
        }, $("<div class='multiLinkContainer'></div>"));
        valArr = valArr.wrap("<div>").parent();
        return valArr[0].innerHTML;
    };

    this.triggerHeap = function (value, type, postVal, bulkType, scope) {
        if (typeof heap === "undefined" || typeof heap.track !== "function") {
            window.heapEventQueue = window.heapEventQueue || [];
            const eventData = {value: value, type: type, postVal: postVal, bulkType: bulkType, scope: scope};
            window.heapEventQueue.push(eventData);
            return;
        }

        if (typeof heap != "undefined" && heap.track) {
            var obj = {value: ""};
            if (type == "search") {
                if (value == -1) {
                    obj['type'] = "Advanced Search";
                } else if (value == 0 || value == 1) {
                    obj['type'] = "Contract Document";
                } else if (value == 2) {
                    obj['type'] = "Attachment";
                } else if (value == 5) {
                    obj['type'] = "Entity";
                } else {
                    obj['type'] = "Undefined";
                }
                postVal ? obj['Searched Entity'] = postVal : '';
                heap.track('Search Activity', obj);
            } else if (type == "bulk") {
                if (value == 1) {
                    obj['Bulk Type'] = "Bulk Edit";
                    obj['Number of Records Selected'] = checkedVal.length;
                } else if (value == 2) {
                    obj['Bulk Type'] = "Bulk Action";
                    obj['Number of Records Selected'] = checkedVal.length;
                } else if (value == 3) {
                    obj['Bulk Type'] = "Bulk Upload";
                    obj['Number of Records Selected'] = checkedVal.length;
                    scope && scope.selectedOption && (obj['selectedOption'] = scope.selectedOption);
                    if (event.target && event.target.innerHTML == intl_msg[23753]) { // For Raw Data
                        obj['Bulk Type'] = "Bulk Upload " + event.target.innerHTML;
                    }
                } else if (value == 4) {
                    obj['Bulk Type'] = "Bulk Update";
                    obj['Number of Records Selected'] = checkedVal.length;
                } else if (value == 5) {
                    obj['Bulk Type'] = "Bulk Create";
                }
                postVal ? obj['Bulk Entity'] = postVal : '';
                bulkType ? obj['Bulk Type'] = bulkType : '';
                heap.track('Bulk Activity', obj);
            } else if (type == "AskSirion") {
                heap.track('AskSirion Daily Query Submissions');
            } else if (type == "EnabledType") {
                obj[value] = postVal;
                heap.track('Enabled Type', obj);
            } else if (type == "TTDQueryCount") {
                obj['TTD - Query Count'] = "Submitted";
                heap.track('TTD Query Count', obj);
            }
        }
    }

    this.transformEntityName = function (entity) {
        entity = entity.replace("tbl", "");
        return entity[0].toUpperCase() + entity.slice(1, entity.length);
    }

    this.getInfoData = function () {
        return {
            api: "/listRenderer/list/432/listdata?version=2.0",
            post: {
                "filterMap": {
                    "entityTypeId": 316,
                    "offset": 0, "size": 200,
                    "orderByColumnName": "id",
                    "orderDirection": "desc nulls last",
                    "filterJson": {
                        "368": {
                            "multiselectValues": {
                                "SELECTEDDATA": [{"id": "3", "name": "INPROGRESS"}]
                            },
                            "filterId": 368,
                            "filterName": "statusId",
                            "entityFieldHtmlType": null,
                            "entityFieldId": null
                        }
                    }
                },
                "selectedColumns": listJson.columnsGroup
            }
        }
    }
    this.formatInfoData = function (arr, docNameCOlId, docStatusColId, docStageColId) {
        return arr.map(function (obj) {
            var obj = {
                "name": obj[docNameCOlId].value && obj[docNameCOlId].value.split(":;")[0],
                "id": obj[docNameCOlId].value && obj[docNameCOlId].value.split(":;")[1],
                "status": obj[docStatusColId].value && (obj[docStageColId].value || obj[docStatusColId].value.split(":;")[0]),
                "statusId": obj[docStatusColId].value && obj[docStatusColId].value.split(":;")[1],
            }
            obj.ext = SirionUtils.getExtension(obj.name);
            return obj;
        })
    }
    this.checkUrlForHash = function (url) {
        let apiList = ["/sideLayout", "/additional/details", "/v2/summarylayout", "/searchfilter/data", "/searchLayout/entityTypes", "/v2/createlinks"],
            returnVal = false;
        if (!urlHash) return returnVal;
        apiList.forEach(function (item) {
            if (url.indexOf(item) > -1) {
                returnVal = true;
                return;
            }
        });
        return returnVal;
    }
    this.stringToHash = function (string) {
        var hash = 0;
        if (string.length == 0) return hash;
        for (i = 0; i < string.length; i++) {
            char = string.charCodeAt(i);
            hash = ((hash << 5) - hash) + char;
            hash = hash & hash;
        }
        return hash;
    }
    this.getCaptcha = function (fieldProps) {
        if (fieldProps && (fieldProps.captcha == false || !fieldProps.captcha || (_.has(fieldProps, "onClick.message") && fieldProps.onClick.message.indexOf("captchaField") > -1))) {
            return "";
        }
        let captchaText = Math.floor(1000 + Math.random() * 9000),
            message = intl_msg[31205] ? intl_msg[31205] : "Type digits below to perform this action",
            captchaField = "<div class='captchaField'>" + message + "<br /><input type='number' id='captcha-input' min='0' max='9999' onkeypress=\"return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57\"  oninput=\"if(value.length>4)value=value.slice(0,4)\" autofocus placeholder='" + intl_msg[29072] + "'><span>" + captchaText + "</span><div class='showErrorMsg'></div></div>";
        return captchaField;
    }
    this.confirmCaptcha = function () {
        let captchaElem = angular.element(".captchaField"),
            returnVal = captchaElem.find("input").val() == captchaElem.find("span").text();
        if (captchaElem.length == 0) {
            return true;
        }
        if (!returnVal) {
            captchaElem.find("input").addClass("errorClass");
            document.getElementsByClassName('showErrorMsg')[0].innerHTML = (captchaElem.find("input").val() == "" ||
                !captchaElem.find("input").val()) ? intl_msg[31165] :
                intl_msg[31124] || 'The captcha you have entered is incorrect';
        }
        return returnVal;
    }

    this.convertDateToFormat = function (date, format) {
        let r = moment(date, this.getDBDateTimeFormat());
        let d = $.format.date(r._d, format.replace(/[zhma]/g, "").trim());
        return d;
    }

    this.showAll = function (arr) {
        const ele = $(this).closest(".toAppend");
        ele.empty();
        var arrcopy = arr.split(",");

        for (val in arrcopy) {
            var avatar = SirionUtils.getAvatarImage(arrcopy[val])

            if (arrcopy[val].includes("#GROUP")) {
                let group = 'src/react/src/CSS/images/User_group.svg'
                var str = arrcopy[val].split("#");
                let userImg = $("<span class='use_grp' style='margin: 2px 0'>" +
                    "<span> <img loading='lazy' alt='Group Avatar' class='sirion_avatar avatar_size' src=" + group + "  /></span>" +
                    "<span class='avatar_text'>" + str[2].trim() + ',  </span> ' +
                    '</span>');
                ele.append(userImg);
            } else {
                let userImg = $("<span  class='use_grp' style='margin: 2px 0'>" +
                    "<span> <img loading='lazy' alt='User Avatar' class='sirion_avatar avatar_size' src=" + avatar + "  /></span>" +
                    "<span class='avatar_text'>" + arrcopy[val].trim() + ',  </span> ' +
                    '</span>');
                ele.append(userImg);
            }
        }
        $(window).resize();
        ele.append('<a onclick="SirionUtils.showOne.call(this,\'' + arr + '\');"> less</a>')
    }

    this.firstUser = function (arr) {
        $(this).closest(".toAppend").remove();
        var arr1 = arr.split(",");
        let firstUser = arr1[0];

        var avatar = SirionUtils.getAvatarImage(firstUser)
        let userImg = '<span class=\'toAppend\'>';

        if(firstUser.indexOf(SirionUtils.LIST_USER_REPLACE_TEXT)>-1) {
            firstUser = firstUser.replace(SirionUtils.LIST_USER_REPLACE_TEXT, SirionUtils.LIST_USER_ICON);
        } else {
            userImg += `<div id='toAppend'><img loading='lazy' alt='User Avatar' class='sirion_avatar avatar_size' src='${avatar}' />`;
        }

        userImg += `<span class='avatar_text'>${firstUser}, </span>
             <a onclick='SirionUtils.showAll.call(this,\"${arr}\")'> more </a></span>`
        return userImg;
    }

    this.showOne = function (arr) {
        const ele = $(this).closest(".toAppend");
        ele.empty();
        ele.append(SirionUtils.firstUser(arr));
        $(window).resize();
    }

    this.getMultipleDocTags = function (value, delimitter, limit, filterId, handleClick, isTabFilter = false) {
        var arr = [];
        isTabFilter = isTabFilter ? true : false
        if (!delimitter)
            arr = value.split("::");
        else
            arr = value.split(delimitter);
        var rootScope = $("#data-ng-app").scope(), extraClass = "";
        if (rootScope?.data?.entityTypeId?.values == 61) {
            extraClass = "cursorDefault "
        }
        var privateFn = {
            getHTML: function (obj, index) {
                var objArr = obj.split(":;");
                var link = $('<span></span>').attr({
                    title: objArr[0],
                    class: 'tags ' + extraClass + (index>=limit?"moreThanLimit":""),
                    onclick: handleClick ? "clickOnDocTag('" + objArr[1] + "','" + objArr[0] + "'," + filterId + "," + isTabFilter + ")" : ''
                }).html(objArr[0]);
                return link;
            },
            getSeparator: function (index) {
                return $("<span>").attr({
                    class: index >= limit ? "moreThanLimit" : ""
                }).html("");
            }
        }
        arr = _.sortBy(arr, [function (o) {
            return o.split(":;")[0].toLowerCase()
        }]);
        var valArr = arr.reduce(function (acc, obj, index) {
            var link = privateFn.getHTML(obj, index);
            if (index) {
                acc = acc.append(privateFn.getSeparator(index));
            }
            acc = acc.append(link);

            if (index + 1 == arr.length && index >= limit) {
                var lessBtn = $('<a class="minBtn"></a>').html(intl_msg[27449] || "less"),
                    moreBtn = $('<a class="maxBtn"></a>').html((arr.length - limit) + " " + (intl_msg[27450] || "More"));
                acc = acc.append(lessBtn).append(moreBtn);
            }
            return acc;
        }, $("<div class='multiLinkContainer'></div>"));
        valArr = valArr.wrap("<div>").parent();
        return valArr[0].innerHTML;
    };
    this.checkForSearchAndLocalFilters = function (scope,deleteUuid=false) {
        const doNotAppendUuid =  JSON.parse(localStorage.getItem("doNotAppendUuid"));
        if (typeof multiEntityItems != "undefined" && multiEntityItems && multiEntityItems.length > 1 && $.urlParam("searchFilters")
            || (scope && scope.isAEListing && !!window.contractId && scope.filterRendered == false && !doNotAppendUuid)) {
            return true;
        }
        if(deleteUuid && doNotAppendUuid){
            localStorage.removeItem('doNotAppendUuid');
        }
        return false;
    }
    this.checkForPartialResetFilters = function (scope) {
        if (_.get(window.checkedItemList, "length") && scope && scope.isAEListing && scope.filterRendered == false && $.urlParam("partialReset")) {
            return true;
        }
        return false;
    }
    this.getFilterParamObject = function (size, offset, orderByColumnName, orderDirection, JsonObj, entityTypeId, searchName) {

        /* Function to create param object based on parameters passed */
        let obj = {
            "offset": offset,
            "size": size,
            "orderByColumnName": orderByColumnName,
            "orderDirection": orderDirection,
            "entityTypeId": entityTypeId,
            "filterJson": JsonObj,
        }
        if (searchName) {
            obj.searchName = searchName
        }
        return obj;
    }
    this.updateObjectWithData = function (data, entityTypeId, flag) {
        var dataToPost = JSON.parse(data);
        if (dataToPost.filterMap && !dataToPost.filterMap.size) {
            dataToPost.filterMap.size = self.DEFAULT_PAGE_SIZE;
            dataToPost.filterMap.offset = 0;
        }
        let customFilter = SirionUtils.getSearchIdsFilterData();
        const partialReset = $.urlParam("partialReset");
        let allowDuplicate = !!contractId && listId == 432 ? true : false
        /*if(allowDuplicate){
            customFilter.filterId = "438";
            customFilter.filterName = "duplicatedocs";
            customFilter.multiselectValues = {}
            customFilter.multiselectValues.SELECTEDDATA = [{id: 1}];
            delete customFilter.min;
        }*/
        if(partialReset && dataToPost.filterMap.filterJson['368']) {
            return JSON.stringify(dataToPost);
        }
        if (partialReset) {
            customFilter.filterId = "368";
            customFilter.filterName = "statusId";
            customFilter.multiselectValues = {}
            customFilter.multiselectValues.SELECTEDDATA = [{id: 4, name: "COMPLETED"}];
            // customFilter.offset = 0;
            // customFilter.size = 20;
            delete customFilter.min;
        }
        if (_.isEmpty(dataToPost.filterMap) || dataToPost.filterMap && _.isEmpty(dataToPost.filterMap.filterJson)) {
            var filterMap = {};
            if(!!allowDuplicate){
                // filterMap["438"] = customFilter;
                allowDuplicate = null;
            } else if(partialReset && customFilter) {
                filterMap["368"] = customFilter;
            } else if(customFilter && this.haveSearchFilterFrombackend()) {
                if(_.isEmpty(window?.payload?.filterMap)){
                    filterMap["772"] = customFilter;
                    window.payload['filterMap'] = {};
                }
            } else if(customFilter) {
                filterMap["448"] = customFilter;
            }

            if (flag) {
                return filterMap;
            }
            dataToPost.filterMap = this.getFilterParamObject(dataToPost.filterMap.size, dataToPost.filterMap.offset, 'id', 'desc nulls last', filterMap, entityTypeId, dataToPost.filterMap.searchName ? dataToPost.filterMap.searchName : null);
        } else if (_.get(dataToPost, "filterMap.filterJson")) {
            if(!_.isEmpty(window.multiEntityItems)){
                if(this.haveSearchFilterFrombackend()){
                    if(!window?.payload?.filterMap?.filterJson?.["772"]) dataToPost.filterMap.filterJson[772] = customFilter;
                }else {
                    dataToPost.filterMap.filterJson[448] = customFilter;
                }
            }
        }
        if(this.checkForSearchAndLocalFilters()){
            const filterCustomId = this.haveSearchFilterFrombackend() ? '772' : '448';
            if(!window.payload.filterMap){
                window.payload.filterMap = {};
                window.payload.filterMap.filterJson = {};
                window.payload.filterMap.filterJson[filterCustomId] = dataToPost.filterMap.filterJson[filterCustomId];
            }else if (!!window.payload.filterMap.filterJson){
                window.payload.filterMap.filterJson[filterCustomId] = dataToPost.filterMap.filterJson[filterCustomId]
            }
        }
        return JSON.stringify(dataToPost);
    }

    this.haveSearchFilterFrombackend = () => {
        return !_.isEmpty(window.multiEntityItems) && !_.isEmpty(window.multiEntityFilterFromBackend)
    }

    this.doesNotHaveChkBoxHandler = function (event, disabled, currentTarget) {
        if (!event && !currentTarget)
            return;
        let element = currentTarget;
        if (event)
            element = $(event.currentTarget);

        element = element.closest('.jx-listFilters');
        let currentElement = element.find('.applicable-operator');
        if (currentElement) {
            let elementText = currentElement.find('.extra-options-span').html(),
                isTargetElement = elementText && elementText.indexOf("Does Not Have") > -1;
            if (isTargetElement) {
                let elm = currentElement.find('.extra-options-input');
                if (disabled && elm[0].checked) {
                    elm.prop('checked', false);
                    elm[0].checked = false;
                }
                elm.prop('disabled', disabled);
            }
        }
    }

    this.createAutoSelectFieldLayout = function (args) {
        let name = args.name || {},
            id = args.id || {},
            label = args.label || {},
            type = args.type || {};
        return {
            "id": id,
            "name": name,
            "label": label,
            "type": type,
            "orderSeq": 10,
            "properties": {},
            "displayMode": "editable",
            "dynamicField": false,
            "editableHtmlType": 3,
            "autoComplete": false,
            "enableListView": false,
            "bulkEditable": false,
            "multiEntitySupport": false
        }
    }
    this.flickerIssueFixForBrowser = function (browser, domElmIdentifier = []) {
        if (browser && navigator.userAgent.indexOf(browser) != -1) {
            domElmIdentifier.forEach(identifier => {
                $(identifier).addClass("browser-hide");
            });
            setTimeout(function () {
                domElmIdentifier.forEach(identifier => {
                    $(identifier).removeClass('browser-hide');
                });
            }, 500)
        }
    }
    this.removeURLParameterVer2 = function (url, parameter) {
        if (parameter && parameter.trim()) {
            parameter = parameter.trim();
            let replaceStr = "&" + parameter + "(=[^&]*)?|^" + parameter + "(=[^&]*)?&?";
            var regex = new RegExp(replaceStr);
            return url.replace(regex, "");
        }
        return url;
    }

    this.getParameterValueFromURL = function (url, parameter) {
        if (url && parameter) {
            let regExStr = parameter + "=([^&]+)",
                regex = new RegExp(regExStr),
                value = regex.exec(url) && regex.exec(url)[1];
            return value || '';
        }
    }
    this.isCommunicationCommentField = function (elm) {
        if (elm) {
            const isComment = $(elm).closest('.iframe-comments').length || $(elm).closest('.communicationPanel').length;
            return !!isComment;
        }
        return false;
    }
    this.alphaNumericCheck = function (str, specialChars = []) {
        let code, len;
        let isNumeric = isAlpha = isSpecialChars = false;
        const specialCharsCodes = specialChars.map(char => char.charCodeAt());

        for (let i = 0, len = str.length; i < len; i++) {
            code = str.charCodeAt(i);

            switch (true) {
                case code > 47 && code < 58: // check if 0-9
                    isNumeric = true;
                    break;

                case (code > 64 && code < 91) || (code > 96 && code < 123): // check if A-Z or a-z
                    isAlpha = true;
                    break;

                case specialCharsCodes.includes(code): // check if in special characters
                    isSpecialChars = true;
                    break;

                default:
                    // not 0-9, not A-Z or a-z
                    return false;
            }
        }
        return isNumeric || isAlpha || isSpecialChars;
    }
    this.downloadListDocument = function (url, obj) {
        var form = $('<form  action="' + window.appName + url + '" method="post" />');
        obj = JSON.stringify(obj);
        var input = $("<input type='hidden' name='jsonData' value='" + obj + "' />");
        form.append(input);
        const csrfToken = window.localStorage.getItem('_csrf_token');
        const csrfParam = window.localStorage.getItem('_csrf_param');
        if (csrfToken && csrfParam) {
            form.append($('<input>', { type: 'hidden', name: csrfParam, value: csrfToken }));
        }
        $("body").append(form);
        form.submit();
        $(document).click();

    }
    this.generateUniqueID = function () {
        return Math.floor(Math.random() * Date.now());
    }

    this.cleanupDetailsPopup = function (el) {
        const popupList = el.querySelectorAll('.mention-detailed-view');
        popupList.forEach(popupItem => {
            popupItem && popupItem.remove();
        });
    }

    this.popUpAdjustmentFor150Scaling = function (_position, { insetInlineStart, bottom, top, insetInlineEnd }) {
        _position.insetInlineStart && (_position.insetInlineStart /= insetInlineStart);
        _position.top && (_position.top /= top);
        _position.bottom && (_position.bottom /= bottom);
        _position.insetInlineEnd && (_position.insetInlineEnd /= insetInlineEnd);
    }

    this.getPurifiedValue = function (value) {
        if (value == undefined)
            return value;
        let commVal = value;
        let tempDiv = document.createElement('div');
        tempDiv.innerHTML = commVal;
        SirionUtils.cleanupDetailsPopup(tempDiv);

        value = tempDiv.innerHTML;
        let targetBlank;
        DOMPurify.addHook('beforeSanitizeAttributes', function (node) {
            // set all elements owning target to target=_blank
            if ('target' in node && node.getAttribute('target')=='_blank'){
                targetBlank = true;
            } else if(node.localName == 'a'){
                node.setAttribute('target', '_top');
                targetBlank = false;
            }
        });
        DOMPurify.addHook('afterSanitizeAttributes', function (node) {
            // set all elements owning target to target=_blank
            if ('target' in node) {
                node.setAttribute('target', targetBlank?'_blank':'_top');
                node.setAttribute('rel', 'noopener noreferrer');
            }
        });
        if(!window.xssEnable) {
            if(value){
                value = this.updateAnchorTags(value);
            }
            return value;
        }

        const data = _.unescape(value);
        let purified = typeof DOMPurify !== 'undefined' && DOMPurify.sanitize(data);
        purified = _.unescape(purified);
        return purified || data;
    }

    this.updateAnchorTags = function(value){
        let parser = new DOMParser();
        let document = parser.parseFromString(value, 'text/html');
        let anchorTags = Array.from(document.getElementsByTagName('a'));
        anchorTags.forEach(node =>{
            if(!node.getAttribute('target')){
                node.setAttribute('target', '_top');
            }
        });
        return _.unescape(document.body.innerHTML);
    }

    this.removeScriptStyleTagsFromHtml = function (value) {
        const dataStr = value || '';
        return dataStr.replace(/(<style[\w\W]+style>)/g, "").replace(/(<script[\w\W]+script>)/g, "");
    }

    this.shouldPreserveRawTextInput = function (el) {
        if (!el || !el.getAttribute) {
            return false;
        }
        if (el.getAttribute('data-preserve-raw-text') === 'true') {
            return true;
        }
        if (el.getAttribute('name') === 'name') {
            return true;
        }
        if (el.classList && el.classList.contains('skip_global_purify')) {
            return true;
        }
        return !!(el.closest && el.closest('.skip_global_purify'));
    }

    this.purifyData = _.debounce(function (val, callback) {
        const pVal = SirionUtils.getPurifiedValue(val);
        callback && callback(pVal);
    }, 0)
    this.openSirionDialogs = function (args) {
        let rootScope = $("#data-ng-app").scope();
        var {popupType, str, heading, yesCbFn, noCbFn, field, yesName, noName, rmvCloseBtn, type, _customClass, onlyYesButton, url, closeCallBack, isfirstTabSpecificEntity, hideLoader, hideBtn, sessionTimeout} = args;
        if (popupType == 'confirm') {
            mcxDialog.confirm(str, heading, yesCbFn, noCbFn, field, yesName, noName, rmvCloseBtn, type, _customClass, onlyYesButton);
        } else if (popupType == 'alert') {
            mcxDialog.alert(str, heading, yesCbFn, noCbFn, yesName, noName, url, closeCallBack, rmvCloseBtn, isfirstTabSpecificEntity, hideLoader, hideBtn, sessionTimeout);
        } else {
            popupType = '';
            mcxDialog.close();
        }
    rootScope.popupType = popupType;
    }


    this.revalidateAPIurl = function (url) {
        if (url == 'baseinvoice') {
            url = 'baseInvoice';
        }
        return url;
    }
    this.addParameterToUrl = function (url, key, value) {
        const keys = [].concat(key || []);
        const values = [].concat(value || []);
        keys.forEach((key,idx) => {
            url = this.removeURLParameter(url, key);
            const _value = values[idx];
            if (url && key && _value) {
                const operator = url.indexOf("?") == -1 ? '?' : '&';
                url += `${operator}${key}=${_value || ''}`;
            }
        })
        return url;
    }
    this.isWorkflowTrigger = function () {
        let paramValue = this.getParameterValueFromURL(window.location.href, "wfId")
        return paramValue && paramValue != "undefined" ? true : false;
    };
    this.openReactModalFromAngular = function (mountAt, propsToPass, actionType, componentName, modalChannelName, subscriptionChannelName) {
        var interval = setInterval(() => {
            if ($(mountAt).length) {
                clearInterval(interval);
                if (!$(mountAt).children().length) {
                    window.reactComponents.mountDynamicComponent(mountAt, componentName, propsToPass);
                } else {
                    window.sarc.channelBroadcast(modalChannelName, {
                        actionType: actionType,
                        payload: propsToPass,
                    }, subscriptionChannelName)
                }
            }
        }, 10)
    }
    this.updateSelectedClauseIndex = function (selectedClauses) {
        const hasDefinations = !!(this && this.definitionsCount);
        let defItem = false;
        let j = 0;
        _.forEach(selectedClauses, (clauseItem, index) => {
            if(clauseItem.definition) {
                defItem = true;
            }
            if (clauseItem.lineItem) {
                if (!clauseItem.numbering) {
                    j++;
                }
            }
            // (clauseItem.category && clauseItem.category.value === 'Definitions') && j++;
            clauseItem.clauseIndex = index - j + 1 - (defItem ? (hasDefinations ? 0 : 1) : 0 );
        });
        return selectedClauses;
    }

    this.getHashSegment = (url = window.location.href) => {
        const hash = new URL(url).hash;
        const cleanHash = hash.split('?')[0];
        const segments = cleanHash.split('/').filter(Boolean);
        return segments;
    }

    this.getEntityTypeFromUrl = function () {
        const hashSegments = this.getHashSegment();
        return hashSegments[2];
    }
    this.appendTblToUrl = function (url) {
        const excludedType = ['changerequests', 'clause', 'contracttemplate'];
        const exclude = excludedType.includes(url);
        if (url && !exclude) {
            const hasTbl = url.includes('tbl');
            return hasTbl ? url : 'tbl' + url;
        }
        return url;

    }

    this.clearSessionStorage = function () {
        sessionStorage.removeItem('showAmendment');
        sessionStorage.removeItem('api');
        sessionStorage.removeItem('selectedContractId');
        sessionStorage.removeItem('commonFieldActualData');
        sessionStorage.removeItem('pageLabel');
        sessionStorage.removeItem('showAmendment');
        sessionStorage.removeItem('savedBodyReq');
        sessionStorage.removeItem('cdrToContractPorting');
        sessionStorage.removeItem('cdrToContractField');
        sessionStorage.removeItem('multiSupplierApi');
        sessionStorage.removeItem('contractNewApi');
        sessionStorage.removeItem('dataKeysToRemove');
        sessionStorage.removeItem('contractFromCDRData');
        sessionStorage.removeItem('createFromShowPage');
        sessionStorage.removeItem('showErrorModal');
        sessionStorage.removeItem('entityTypeId');
        sessionStorage.removeItem('aeDocObject');
        sessionStorage.removeItem('wfFreeFormAPI');
    }
    this.clearAEObjectFromSessionStorage = function() {
        sessionStorage.removeItem('aeDocObject');
    }

    this.getCancelBtnLayout = function () {
        return {
            "name": "Cancel",
            "label": intl_msg[26837] || "Cancel",
            "requestType": "get",
            "clientValidation": false,
            "confirmationForBlockedEntities": false,
            "confirmation": false,
            "message": "null",
            "type": "button",
            "secondaryEntity": false,
            "properties": {
                "onClick": {
                    "name": "basicConfirmation",
                    "title": "CONFIRMATION",
                    "message": intl_msg[7014] || "Are you sure you would like to cancel?",
                    "success": "closePopUp"
                }
            },
            "hideWorkflowButton": false,
            "cancelType": true
        }
    }
    this.getEntityIdFromUrl = function () {
        const urlSlashSeparatedList = window.location.hash.split('/');
        if(['show','update','clone'].includes(urlSlashSeparatedList[1]) && urlSlashSeparatedList[3]) {
            return urlSlashSeparatedList[3].split('?')[0];
        }
        return null;
    }

    this.disableSubmitButton = function (elm, delay) {
        let element = document.getElementsByClassName(elm)[0];
        if (!_.isEmpty(element)) {
            element.style.pointerEvents = 'none';
            setTimeout(() => {
                element.style.pointerEvents = 'all';
            }, delay)
        }
    }

    this.addBeforeUnload = function () {
        $(window).bind('beforeunload',function (event) {
            event.preventDefault();
            return "You are leaving the page";
        });
        $(window).bind('popstate',function (event) {
            event.preventDefault();
            return "You are leaving the page";
        });
    }

    this.remToBasePixel = function (data, unit) {
        const htmlStr = data || '';
        return htmlStr.replace(/([+-]?(?=\.\d|\d)(?:\d+)?(?:\.?\d*))(?:[eE]([+-]?\d+))?rem+/g, (unit || '14px'));
    }

    this.clearRandomTooltips = function (maxRunTime = 1000) {
        const recurringTime = 250;
        maxRunTime = maxRunTime >= recurringTime ? maxRunTime : recurringTime;
        var timer = setInterval(() => $('body > .custom_tooltip').remove(), recurringTime);
        setTimeout(() => clearInterval(timer), maxRunTime);
    }

    this.updateCDRDocStatus = function (selectedModel, arrJson, docFileId) {
        if (selectedModel["data"]["type"]) {
            if (Array.isArray(selectedModel["data"]["type"]) && selectedModel["data"]["type"].length) {
                arrJson.templateTypeId = selectedModel["data"]["type"][0]["id"];
            } else {
                arrJson.templateTypeId = selectedModel["data"]["type"]["id"];
            }
        }
        arrJson.documentFileId = docFileId;
        if (selectedModel?.data?.document_tag?.length > 0) {
            arrJson.documentTags = selectedModel["data"]["document_tag"].map(function (item) {
                return item["id"];
            });
        }

        if (selectedModel?.data?.classification?.length > 0) {
            let key = "";
            _.forEach(selectedModel["data"]["classification"], function (item) {
                let _itemName = item["orgName"] || item['name'];
                if (_itemName.toLocaleLowerCase() !== intl_msg[27429].toLocaleLowerCase()) {
                    if (_itemName) {
                        if ("Financial" === _itemName) {
                            key = "financial"
                        } else if ("Legal" === _itemName) {
                            key = "legal"
                        } else if ("BusinessCase" === _itemName) {
                            key = "businessCase"
                        }
                    }
                    if (key) {
                        arrJson[key] = true;
                    }
                }
            });
        }
        return arrJson;
    }

    this.dynamicMetadataCleanup = function (payload) {
        let dynData = _.pickBy(payload, fData => fData && fData.isDynData);
        dynData = _.mapValues(dynData, d => {
            delete d.isDynData;
            return d
        });
        if (_.keys(dynData).length) {
            payload["dynamicMetadata"] = {...dynData};
        }
        for (let key in dynData) {
            delete payload[key];
        }
    }

    this.startInfiniteLoader = function () {
        window.infiniteLoaderId = setInterval(() => {
            window.infiniteLoaderId && startLoader();
            !window.infiniteLoaderId && stopLoader();
        }, 10);
    }
    this.stopInfiniteLoader = function () {
        window.infiniteLoaderId && clearInterval(window.infiniteLoaderId);
        $("body").removeClass("overRideLoading");
        stopLoader();
        delete window.infiniteLoaderId
    }
    this.checkPluginsRaiseRequest = () => {
        if (window.location.href.includes('raiseRequest')) {
            const sc = $('#header').scope();
            sc?.raiseRequest?.();
        }
    }

    this.redirectFromRaiseRequest = function() {
        let baseUrl = window.location.href.split(`/${window.envAlias}`)[0];
        if(window.sessionStorage.getItem('raiserequestBaseUrl')) {
            window.location.href = `${baseUrl}/${window.envAlias}${window.sessionStorage.getItem('raiserequestBaseUrl')}`;
        }else if(window.sessionStorage.getItem('raiserequestWFListUrl') && window.sessionStorage.getItem('raiserequestWFListUrl').includes('raise')){
            window.location.href = `${baseUrl}/${window.envAlias}/#/dashboard`;
        }
        this.clearWFsessionItems();
        window.doNotRedirectToPreviousRoute = true;
    }
    this.clearSessionUrl = function () {
        let selectedDocument = JSON.parse(sessionStorage.getItem('selectedDocument'));
        let urlId = window.SirionUtils.getParameterByName('urlId');
        delete selectedDocument[urlId];
        sessionStorage.setItem('selectedDocument', JSON.stringify(selectedDocument));
    }

    this.handleNavigatingBackToEditor = function (event) {
        let validAccessToEditor = sessionStorage.getItem("validAccessToEditor") || null;

        if(!validAccessToEditor || validAccessToEditor == 'false'){
            event.preventDefault();
            sessionStorage.setItem("viaEditorCTA", true);
            this.clearSessionUrl();
            window.history.back();
        }
    }

    this.getCancelDocumentUrl = function () {
        let _cUrlId = sessionStorage.getItem('currentUrlId');
        let _documentFileId = _.get(JSON.parse(sessionStorage.getItem('selectedDocument')), _cUrlId).documentFileId;

        let url = addtStamp("/online/editor/cancel/document/"+_documentFileId, true);
        return url;
    }

    this.clearWFsessionItems = () => {
        ['fromSirionDialogs','raiserequestBaseUrl','fromAEShowPage','raiserequestWFListUrl'].forEach(str =>  window.sessionStorage.removeItem(str));
    }

    this.getSearchIdsFilterData = function(){
        if(!_.isEmpty(window.multiEntityItems)) {
            if(!_.isEmpty(window.multiEntityFilterFromBackend)){
                return window.multiEntityFilterFromBackend["772"];
            }else {
                return {
                    "filterId": "448",
                    "filterName": "entityidsfilter",
                    "entityFieldId": null,
                    "entityFieldHtmlType": null,
                    "min": window.multiEntityItems && window.multiEntityItems.join(",")
                }
            }
        }
        return false
    }

    this.getCreditCalculateString = function(count){
        if (count > 1) {
            return`${count + ' ' + intl_msg[26767]}`;
        } else if (count === 1) {
            return `${count + ' ' + intl_msg[26768]}`;
        }else{
            return '';
        }
    }

    this.getSignType = (signType) => {
        let signTypeName = {
            1: "DocuSign",
            2: "Adobesign",
            3: "NamirialSign",
            4: "MoxisSign",
            5:"LeegalitySign",
            6: "OneSpanSign",
        }
        return signTypeName[signType];
    }

    this.drsErrorCodes = {
        'DRS002': 6432,
        'DRS003': 27946,
        'DRS005': 23397,
        'DRS009': 31682,
        'DRS010': 6500,
        'DRS011': 6500,
        'DRS023': 6560,
    }

    this.getDrsString = function (fileExtval, final=false, aePage) {
        if(aePage){
            return 'AUTOEXTRACTION';
        }else if(['docx','dox','doc'].includes(fileExtval) && final) {
            return 'DRAFT_FINAL_DOCUMENTS'
        }
        return 'DRAFT_NON_WORD_DOCUMENTS'
    }

    this.scrollToBottom = (el) => {
        if (el) el.scrollTop = el.scrollHeight;
    }

    this.scrollToIfNotVisible = (element, container) => {
        const findMe = element,
        contRect = container?.getBoundingClientRect(),
        findMeRect = findMe.getBoundingClientRect();
        if (findMeRect.top < contRect.top || findMeRect.bottom > contRect.bottom || findMeRect.right > contRect.right || findMeRect.left < contRect.left)
            findMe.scrollIntoView({ behavior: "smooth", block: "end" });
    }

    this.changeRouteToUX = function () {
        const pathToChange = ['/beta','/oldux','/alpha'].find(str => window.location.href.indexOf(str) > -1);
        pathToChange && (window.location.href = window.location.href.replace(pathToChange,'/ux'));
    }


    this.getShortCodeIdFromUrl = function () {
        const urlSlashSeparatedList = window.location.hash.split('/');
        let shortCodeId = urlSlashSeparatedList[3];
        shortCodeId = shortCodeId ? shortCodeId.toUpperCase().split('?')[0] : shortCodeId;
        const regex = /^([a-zA-Z]{2,4})([0-9]+)$/;
        res = regex.exec(shortCodeId);
        return res ? res[1] : 0;
    }

    this.redirectFromShortCodeIdToListing = function (newRedirection) {
        let url = window.location.href;

        const entityType = SirionUtils.appendTblToUrl(CodeToURLPartMapping[SirionUtils.getShortCodeIdFromUrl()]);
        const entityListId = sJq._.get(urlToEntityDataMapper,`[${entityType}].listId`);

        if(entityListId) {
            const splitUrl = url.split('#');
            splitUrl[1] = `/listRender/${entityListId}`
            url = splitUrl.join('#');
        } else {
            url = "/#/dashboard";
        }
        if(newRedirection)
            window.location.assign(url);
        else
            window.location.replace(url); // Replace current URL with new one so that if user clicks back button, he cannot acces the corrupted url like /show/tblcontracts/ABCD08200
    }

    this.shortCodeIdPresent = function (path) {
        let splitPath = path?.split('/');
        return splitPath?.length && splitPath[2] && /[a-zA-Z]/.test(splitPath[2]) ? true : false;
    }

    /**
     * This function will return true if the value is null or empty, false otherwise.
     * Specifically written to return true if value is a number 0 (zero) - a valid non empty value
     */
    this.isEmptyVal = function(value){
        return  value === undefined ||
                value === null ||
                (typeof value === "object" && Object.keys(value).length === 0) ||
                (typeof value === "string" && value.trim().length === 0)
    }

    this.isDuplicateRequest = (noCbFn = () => {}) => {
        let rootScope = $("#data-ng-app").scope();
        const downloadRequested = rootScope.downloadAlreadyRequested;
        if (downloadRequested) {
            const args = {
                popupType: 'confirm',
                str: intl_msg[35450] || 'This seems like a duplicate request, we are processing your earlier download request.\nDo you want the system to discard this request?',
                heading: intl_msg[25772],
                yesCbFn: () => {},
                noCbFn
            }
            SirionUtils.openSirionDialogs(args)
            return true;
        }
        rootScope.downloadAlreadyRequested = true;

        if (window.downloadRequestedTimeout) clearTimeout(window.downloadRequestedTimeout);
        window.downloadRequestedTimeout = setTimeout(function () {
            rootScope.downloadAlreadyRequested = false;
        }, this.DUPLICATE_REQUEST_TIME);

        return false;
    }

    this.isElementInViewport = (el) => {
        const rect = el?.getBoundingClientRect();
        if(rect) {
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }
        return false;
    }

    this.hideWatson = function() {
        watsonAssistant.hideWatson();
    }

    this.updateChatTitle = (sessionId, title = '') => {
        const headers = {
            'Content-Type': 'application/json'
        };
        const csrfToken = window.localStorage.getItem('_csrf_token');
        const csrfHeader = window.localStorage.getItem("_csrf_header");
        if (csrfToken && csrfHeader) {
            headers[csrfHeader] = csrfToken;
        }
        return fetch(addtStamp(`/api/v1/ai/mira-bot/chat/${sessionId}`, true), {
            method: 'PATCH',
            headers,
            body: JSON.stringify({
                title: title
            })
        }).then(response => response.json());
    };

    this.getMiraChatSessions = (offset=0,limit=20) => fetch(addtStamp(`/api/v1/ai/mira-bot/chat-sessions?offset=${offset}&limit=${limit}`,true)).then(response => response.json());

    this.getTTMCorpusHistory = (sessionId,offset=0,limit=20) => fetch(addtStamp(`/api/v1/ai/mira-bot/chat-history/${sessionId}?offset=${offset}&limit=${limit}`,true)).then(response => response.json());

    this.initiateMiraNewChatSession = () => fetch(addtStamp("/api/v1/ai/mira-bot/initiate-chat",true)).then(response => response.json());

    this.updateChatFeedback = (chatId, payload) => fetch(addtStamp(`/api/v1/ai/mira-bot/chat-message/feedback/${chatId}`, true), {method: "POST", headers: { "Content-Type": "application/json"}, body: JSON.stringify(payload)}).then(response => response.json());

    this.initiateMiraCorpusChatSession = () => {
        return new Promise((resolve) => {
            const activeSession = sessionStorage.getItem('corpusActiveSession');
            if(!activeSession) {
                this.getMiraChatSessions().then(data => {
                    if(data.response?.length) {
                        sessionStorage.setItem('corpusActiveSession',JSON.stringify(data.response[0]));
                    }
                    resolve(true);
                }).catch(err => {
                    console.error(err);
                    resolve(false);
                })
            }else {
                resolve(true);
            }
        })
    }

    this.getTTMCorpusHistory = (sessionId,offset=0,limit=20) => fetch(addtStamp(`/api/v1/ai/mira-bot/chat-history/${sessionId}?offset=${offset}&limit=${limit}`,true)).then(response => response.json());

    this.getSirionAccessToken = () => fetch(addtStamp("/v1/authHelper/getAccessToken",true)).then(response => response.json());

    this.getExtractedDataForChat =function(enableChatBot,customElement) {
        const isTTMyCorpusPage = window.conditionCheck?.isAskMiraPage();
        const loadMira = (response, resolve) => {
            window.getWatsonAccessToken().then(res => {
                if(response) {
                    delete  window.watsonAssistantChatOptions.element;
                    if(customElement) {
                        window.watsonAssistantChatOptions.clientVersion = "8.5.2";
                        window.watsonAssistantChatOptions.identityToken = res.data.accessToken;
                        window.watsonAssistantChatOptions.showRestartButton = false;
                        window.watsonAssistantChatOptions.openChatByDefault = true;
                        window.watsonAssistantChatOptions.hideCloseButton = true;
                        window.watsonAssistantChatOptions.showCloseAndRestartButton = true;
                        window.watsonAssistantChatOptions.element = customElement;
                        watsonAssistant.checkIfWatsonInitiated().then(res => {
                            !isTTMyCorpusPage && setTimeout(() => {resolve(true)},1000);
                            isTTMyCorpusPage && resolve(true);
                        });
                    }else {
                        const callFn = () => window.sarc.channelBroadcast("miraChatBot",{
                            actionType:'setMinimalAccessToken',
                            token: res.data.accessToken
                        },'miraChatBotSubscription');
                        SirionUtils.sarcChannelExecutionar("miraChatBot",callFn);
                        resolve(true);
                    }
                } else {
                    resolve(false);
                }
            }).catch((error) => window.systemWarning(error));
        }
        return new Promise((resolve) => {
            if (enableChatBot) {
                if(isTTMyCorpusPage) {
                    this.getSirionAccessToken().then(data => {
                        resolve(true);
                    }).catch(e => console.error(e));
                }else if(!window.isAskSirionCopilot){
                    onLoadHandlerForChatJs.getSummaryForMira().then(res => {
                        loadMira(res, resolve);
                    });
                }
            } else resolve(false)
        })
    }

    this.removeDocHighLights = function () {
        // Remove doc highlights
        const iframeElement = document.getElementsByClassName('iframe_contract_template')[0]?.contentWindow;
        if(iframeElement) {
            Array.from(iframeElement.document.querySelectorAll('.highlight-box')).forEach(box => box.remove());
            iframeElement.window.highLights = {};
        }
    }

    this.calculateCoordintes = function(response,fromCitation){
        let newAPICoordinates = [];
        (fromCitation ? response : response.data.entity).forEach(function (en) {
            let coordinateList = [];
             _.forEach(en.coordinateInfoList,function (coordinates) {
                 _.forEach(coordinates.coordinateList,function (coordinate,index) {
                    let coordinateProperties = {
                        pageNumber: coordinates.pageNumber,
                        colorCode: en.annotationSubCategory.colorCode,
                        name: en.annotationSubCategory.name,
                        categoryId: en.annotationSubCategory.id,
                        isStart: index === 0,
                        isEnd: index === (coordinates.coordinateList.length - 1),
                        ...(!fromCitation && { 
                            text: en.text,
                            textId: en.annotationSubCategory.name === 'clause' ? en.dataMap.textId : '',
                         })
                    };
                    let coordinateObject = Object.assign({},coordinate,coordinateProperties);
                    coordinateList.push(coordinateObject);
                });
            });
            newAPICoordinates.push(coordinateList);
        });
        let cordinatesListMutated = [];
        newAPICoordinates.forEach(function(coordinates){
            coordinates.forEach(function(coordinate){
                cordinatesListMutated.push(coordinate);
            })
        });
        return cordinatesListMutated;
    }

    this.highlightCitations = function (pagenum, coordinates, id) {
            var iframeElement = document.getElementsByClassName('iframe_contract_template')[0].contentWindow;
            var coordinateArray = this.calculateCoordintes(coordinates,true);
            var cos =  _.size(coordinateArray) > 0 ? coordinateArray : (typeof coordinates === 'string' ? JSON.parse(coordinates) : coordinates);
            cos = iframeElement.coordinatesConverter(cos, true);
            var highLight = {
                highLightId: id,
                containers: []
            };
            if (cos.length) {
                cos.forEach(function (co) {
                    highLight.containers.push({
                        x:co.x,
                        y:co.y,
                        x2:co.x2,
                        y2:co.y2,
                        pageno: co.pageNumber,
                        colorCode: co.colorCode,
                        name: co.name,
                        coordinateApiFlag : true,
                        categoryId: co.categoryId
                    })
                })
            }
            if (highLight.containers.length) {
                iframeElement.entityHighLightFromAE(highLight, pagenum);
            }
    }

    this.getDocPageHeightWidth = function(pageNo,iframe) {
        return new Promise(function (resolve) {
            const iframeElement = iframe || document.getElementsByClassName('iframe_contract_template')[0]?.contentWindow;
            if(iframeElement) {
                iframeElement.manualAutoScroll(pageNo).then(res => {
                    const page = iframeElement.document.querySelector(`#viewerContainer .page[data-page-number="${pageNo}"]`);
                    if(page) {
                        resolve({
                            height: page?.offsetHeight || 0,
                            width: page.offsetWidth
                        })
                    }else resolve(null);
                });
            }
        })
    }

    this.applyCliFiltersColumnOrder = function (listJson) {
        var listId = listJson?.id;
        var _cliInfo = window.resultPageListingData?.[listId];
        if (!window.conditionCheck?.isSearchResultPage() || !_cliInfo?.metadataUrl || !listJson?.columns?.length) {
            return listJson;
        }
        var filtersColumns = _cliInfo.selectedColumns || _cliInfo.columns;
        if (!filtersColumns?.length) {
            return listJson;
        }
        var columnByQueryName = {};
        listJson.columns.forEach(function (col) {
            if (col.queryName) {
                columnByQueryName[col.queryName] = col;
            }
        });
        var orderedColumns = [];
        var used = {};
        filtersColumns.forEach(function (fc, index) {
            var qn = fc.columnQueryName;
            if (!qn) {
                return;
            }
            var col = columnByQueryName[qn];
            if (col && !used[qn]) {
                col.order = index;
                orderedColumns.push(col);
                used[qn] = true;
            }
        });
        listJson.columns.forEach(function (col) {
            if (col.queryName && !used[col.queryName]) {
                col.order = orderedColumns.length;
                orderedColumns.push(col);
                used[col.queryName] = true;
            }
        });
        listJson.columns = orderedColumns;
        return listJson;
    };

    this.getListingColumnsForMira = function (columns,listJson) {
        function moveBulkCheckboxToStart(arr) {
            return arr.sort((a, b) => {
                const aIsBulk = (a.columnQueryName || a.queryName) === "bulkcheckbox";
                const bIsBulk = (b.columnQueryName || b.queryName) === "bulkcheckbox";
                if (aIsBulk === bIsBulk) return 0;
                return aIsBulk ? -1 : 1;
            });
        }
        let selectedColumn =[], _modifiedCols = [];
        var _cliMatchInfo = window.resultPageListingData?.[listJson?.id];
        var _isCliMatch = window.conditionCheck?.isSearchResultPage() && !!_cliMatchInfo?.metadataUrl;

        if(!_.isEmpty(columns) && !_.isEmpty(listJson)) {
            if(_isCliMatch) {
                selectedColumn = listJson?.columns?.filter(obj2 => columns.some(obj1 => obj1.columnQueryName && obj1.columnQueryName === obj2.queryName)) || [];
            } else {
                selectedColumn = listJson?.columns?.filter(obj2 => columns.some(obj1 => obj1.id === obj2.id || obj1.columnId === obj2.id || (obj1.columnQueryName && obj1.columnQueryName === obj2.queryName))) || [];
            }
            //added this code to maintain the column order as per the BE returning in the filters api
            let selectedColumnObj = selectedColumn?.reduce((acc, curr) => {
                acc[curr?.id] = curr;
                if(curr?.queryName) acc['qn_' + curr.queryName] = curr;
                return acc;
            },{});
            selectedColumn = columns.reduce((acc, obj) => {
                var matched;
                if(_isCliMatch) {
                    matched = obj.columnQueryName && selectedColumnObj['qn_' + obj.columnQueryName];
                } else {
                    const id = obj.id || obj.columnId;
                    matched = selectedColumnObj[id] || (obj.columnQueryName && selectedColumnObj['qn_' + obj.columnQueryName]);
                }
                if (matched && !acc.includes(matched)) {
                    acc.push(matched);
                }
                return acc;
            }, []) || [];
        }else {
            var _cliListingInfo = window.resultPageListingData?.[listJson?.id];
            var _isCliListing = window.conditionCheck?.isSearchResultPage() && !!_cliListingInfo?.metadataUrl;
            selectedColumn = _isCliListing ? (listJson?.columns?.slice(0) || []) : (listJson?.columns?.slice(0,listJson.maxNumberOfColumns || 8) || []);
            _modifiedCols = selectedColumn.map(col => ({columnId: col.id, columnQueryName: col.queryName}));
        }

        const columnsToPost = columns?.length ? columns : _modifiedCols;

        return {
            selectedColumn: moveBulkCheckboxToStart(selectedColumn),
            columnsToPost: moveBulkCheckboxToStart(columnsToPost)
        }
    }


    this.showThumbButton = function(element,chat_id, insertAfterNode, isChatHistory, selectedRating) {
        const recommendations = [{
            icon: "👍",
            voteType: "UP_VOTE"
        }, {
            icon: "👎",
            voteType: "DOWN_VOTE"
        }];
        if(!_.isEmpty(recommendations)) {
            const div = document.createElement('div');
            div.id = `thumb_button_wrapper_${chat_id}`;
            div.classList.add(`thumb_button_wrapper`);
            recommendations && recommendations.forEach((element, index) => {
                const button = document.createElement('button');

                button.classList.add('custom_defined_button', 'feedback_button', 'WAC__button--base', 'WAC__button--round', 'WAC__button-0', 'WAC__button', 'WAC__button--notSelected')
                button.type = 'button';
                button.innerText = recommendations[index].icon;
                if(selectedRating) {
                    SirionUtils.handleButtonStyles(button, 'add');
                }
                if(selectedRating === recommendations[index].voteType) {
                    button?.classList.add('selected_feedback');
                }
                button.addEventListener('click', function() {
                    let isFeedbackSubmitted = false;
                    div.childNodes.forEach((item) => {
                        if(item?.parentElement?.classList.contains('selected_feedback')) {
                            isFeedbackSubmitted = true;
                        }
                    });
                    if(isFeedbackSubmitted) return;
                    let scrollBottom = false;
                    if(div.parentElement?.classList?.contains('WAC__message--lastMessage') || [...document.querySelectorAll('.thumb_button_wrapper')]?.at(-1)?.id === `thumb_button_wrapper_${chat_id}`) {
                        scrollBottom = true;
                    }
                    const WACFeedback_form = document.querySelector('.WACFeedback_form');
                    WACFeedback_form && WACFeedback_form.remove();
                    SirionUtils.callThumbsApi(chat_id, element.voteType, '', true, this, scrollBottom);
                });
                div.append(button);
            })
            let node = null;
            if(insertAfterNode) {
                if(isChatHistory) {
                    node = element.querySelector('.old_messages .WAC__message');
                    node && node.insertAdjacentElement("afterend", div);
                } else {
                    setTimeout(() => {
                        node = document.querySelector('.WAC__message.WAC__message--lastMessage.WAC__message--suggestionsPadding .WAC__message--padding');
                        node && node.insertAdjacentElement("beforebegin", div);
                    });
                }
            }
            SirionUtils.autoScrollToBottom();
            window.miraCustomResponseWrapper = element;
        }
    }

    this.chipClickHandler = (id) =>  {
        document.querySelector(".selected_chip") && document.querySelector(".selected_chip").classList.remove('selected_chip')
        document.querySelector(`#${id}`) && document.querySelector(`#${id}`).classList.add('selected_chip');
        if(document.querySelector(".selected_chip")) {
            document.querySelector(".submit_feedback").classList.add('enabled_button');
        } else {
            document.querySelector(".submit_feedback") && document.querySelector(".submit_feedback").classList.remove('enabled_button');
        }
    }

    this.submitFeedback = (chatId, voteType) => {
        const feedbackSelected = document.querySelector(".selected_chip").textContent;
        const comments = document.querySelector('.feedback_comments').value;
        const finalFeedback = `${feedbackSelected}:;${comments}`;
        SirionUtils.callThumbsApi(chatId, voteType, finalFeedback, false, null, false);
    }

    this.closeHandler = () => {
        document.querySelector('.WACFeedback_form').remove();
    }

    this.getDefaultMessage = () => {

        setTimeout(() => {
            SirionUtils.closeHandler();
        }, 3000);

        return `<div>
            Thanks for the feedback!
        </div>`;
    }

    this.getFeedbackForm = function(chatId, element, voteType) {
        const feedbackOptions = {
            UP_VOTE: [
                {
                    id: 1,
                    text: 'Correct'
                },
                {
                    id: 2,
                    text: 'Easy to understand'
                },
                {
                    id: 3,
                    text: 'Complete'
                },
                {
                    id: 4,
                    text: 'Other'
                }
            ],
            DOWN_VOTE: [
                {
                    id: 1,
                    text: 'Inaccurate'
                },
                {
                    id: 2,
                    text: 'Not factually correct'
                },
                {
                    id: 3,
                    text: 'Missing context'
                },
                {
                    id: 4,
                    text: 'Other'
                }
            ]
        };

        const getFeedbackChips = function(voteType) {

            let feedbackChipHTML = '<div class="feedback_option_wrapper">';
            feedbackOptions[voteType]?.forEach((item, index) => {
                const id = `feedback_option_chip_${index}`;
                const chipElement = `<div class="feedback_option_chip" id="${id}" onclick="SirionUtils.chipClickHandler('${id}')">${item.text}</div>`;
                feedbackChipHTML += chipElement;
            });
            feedbackChipHTML += '</div>';
            return feedbackChipHTML;
        }

        const getFeedbackHeader = function(voteType) {
            return voteType === "UP_VOTE" ? 'Why have you chosen this rating?' : "Why wasn't this helpful?";
        }

        const getFeedbackPlaceholder = function(voteType) {
            return voteType === "UP_VOTE" ? 'Provide additional feedback' : "How could the output be improved? (optional)";
        }

        const getFeedbackContent = function() {
            return voteType ? `<div class="feedback_wrapper">
                <div>${getFeedbackHeader(voteType)}</div>
                ${getFeedbackChips(voteType)}
                <div class="feedback_comments_wrapper">
                    <textarea class="feedback_comments" placeholder="${getFeedbackPlaceholder(voteType)}"></textarea>
                </div>
                <div>
                    <button class="submit_feedback" onclick="SirionUtils.submitFeedback('${chatId}','${voteType}')">Submit</button>
                </div>
            </div>`: SirionUtils.getDefaultMessage()
        }

        const feedbackForm = `<div class="WACFeedback_body">
            ${getFeedbackContent()}
            <i class="WACFeedback_close icon-cross" onclick="SirionUtils.closeHandler()"></i>
        </div>`
        const modalDiv = document.createElement('div');
        modalDiv.classList.add('WACFeedback_form');
        modalDiv.innerHTML = feedbackForm;
        element.insertAdjacentElement('afterend', modalDiv);
    }

    this.handleButtonStyles = function(selectedElement, actionType) {
        if(actionType === 'add') {
            selectedElement?.setAttribute('disabled', 'disabled');
            selectedElement?.classList.add('feedback_disabled');
            if(selectedElement?.nextElementSibling) {
                selectedElement?.nextElementSibling?.setAttribute('disabled', 'disabled');
                selectedElement?.nextElementSibling?.classList.add('feedback_disabled');
            } else {
                selectedElement?.previousElementSibling?.setAttribute('disabled', 'disabled');
                selectedElement?.previousElementSibling?.classList.add('feedback_disabled');
            }
        } else {
            selectedElement?.removeAttribute('disabled', 'disabled');
            selectedElement?.classList?.remove('feedback_disabled');
            if(selectedElement?.nextElementSibling) {
                selectedElement?.nextElementSibling?.removeAttribute('disabled', 'disabled');
                selectedElement?.nextElementSibling?.classList.remove('feedback_disabled');
            } else {
                selectedElement?.previousElementSibling?.removeAttribute('disabled', 'disabled');
                selectedElement?.previousElementSibling?.classList.remove('feedback_disabled');
            }
        }
    }

    this.callThumbsApi = async function (chatId, rating, feedback, showFeedbackForm, selectedElement, scrollBottom) {
        const payload = !_.isEmpty(feedback) ? {
            rating,
            feedback
        } : {
            rating
        }
        const wrapperElement = document.querySelector(`#thumb_button_wrapper_${chatId}`);
        SirionUtils.handleButtonStyles(selectedElement, 'add');
        const data = await SirionUtils.updateChatFeedback(chatId, payload);
        if(data.success) {
            if(showFeedbackForm) {
                selectedElement?.classList?.add('selected_feedback');
                SirionUtils.getFeedbackForm(chatId, wrapperElement, rating);
            } else {
                document.querySelector('.WACFeedback_form').remove();
                SirionUtils.getFeedbackForm(chatId, wrapperElement, "");
            }
            scrollBottom && SirionUtils.autoScrollToBottom();
        } else {
            Toaster.create(intl_msg[28867]);
            SirionUtils.handleButtonStyles(selectedElement, 'remove');
        }
    }

    this.autoScrollToBottom = function() {
        /*
        * Auto scrolling to the bottom of the page after history is loaded
        * */
        const mainContainer = document.getElementById('WAC__messages');
        if(mainContainer) {
            mainContainer.style.scrollBehavior = "smooth";
            mainContainer.scrollTop = mainContainer.scrollHeight;
        }
    }

    this.SelectedColumnForSearchFilter = (listJson) => {
        var _cliListingInfo = window.resultPageListingData?.[listJson?.id];
        var _isCliListing = window.conditionCheck?.isSearchResultPage() && !!_cliListingInfo?.metadataUrl;
        const defaultSelectColumn = _isCliListing ? (listJson?.columns?.slice(0) || []) : listJson?.columns.slice(0, listJson.maxNumberOfColumns || 8);
        const modifiedCols = defaultSelectColumn.map(col => ({ columnId: col.id, columnQueryName: col.queryName }));
        return modifiedCols;
    }
    this.isRTLenabled = (languageCode) => {
        return window.getCookie("rtl") === "true" || languageCode == "ar" || window.userLanguageCode == "ar";
    }
    this.updateHtmlAttributeForRTL = (languageCode) => {
        const isRtl = this.isRTLenabled(languageCode)
        const htmlElement = document.querySelector("html");
        if(isRtl){
            htmlElement.setAttribute("dir", "rtl");
            htmlElement.setAttribute("lang", "ar");
            window.rtlEnabled = true;
        } else {
            htmlElement.removeAttribute("dir");
            htmlElement.setAttribute("lang", "en");
            window.rtlEnabled = false;
        }
    }

    this.checkForEmptyValue = (value) =>{
        if (value === null || value === undefined) {
            return true;
        }

        if (typeof value === 'boolean' || typeof value === 'number') {
            return false; // Boolean false , Numeric NaN and 0 are not considered empty
        }

        return _.isEmpty(value);
    }

    this.getAuthBasedUrl = (baseUrl) => {
        const isAuthServiceEnabled = getCookie('authServiceEnabled');
        return isAuthServiceEnabled === 'true' ? `/auth${baseUrl}` : baseUrl;
    }

    this.filterJsonObject = (jsonObject, keysList) => {
        const filteredObject = {};
        keysList.forEach(key => {
            if (jsonObject.hasOwnProperty(key)) {
                filteredObject[key] = jsonObject[key];
            }
        });
        return filteredObject;
    }

    this.hasThisFilterApplied = (filterName, filterJson) => {
        const useListingCriteria = window.conditionCheck.isAskMiraPage() || window.conditionCheck.isSearchResultPage();
        let isApplied = false;
        // This if check is for supportng old saved data.
        if(window.conditionCheck.isSearchResultPage()) {
            isApplied = !!_.find((filterJson || window.payload?.filterMap?.filterJson), f => f.filterName == filterName);
            if(isApplied)
                return true;
        }
        if (useListingCriteria && window.listingCriteria) {
            isApplied = checkIfFilterExistsInListingCriteria(window.listingCriteria, filterName);
        } else {
            isApplied = !!_.find((filterJson || window.payload?.filterMap?.filterJson), f => f.filterName == filterName);
        }
        return isApplied;
    };

    function checkIfFilterExistsInListingCriteria(criteria, filterName) {
        // Check if this is a value node
        if (criteria.cType === 'VAL' && criteria.left === filterName && criteria.right) {
            return true;
        }

        // If this is an AND/OR node with a chain, recursively check each item in the chain
        if ((criteria.cType === 'AND' || criteria.cType === 'OR') && Array.isArray(criteria.chain)) {
            return criteria.chain.some(item => checkIfFilterExistsInListingCriteria(item, filterName));
        }

        return false;
    }

    /**
     * Retrieves the filter value from listing criteria for a specific filter
     * @param {Object} criteria - The criteria object to search in
     * @param {string} filterName - The name of the filter to find
     * @returns {Array|null} - The filter value array if found, null otherwise
     */
    this.getFilterValueFromListingCriteria = (criteria, filterName) => {
        if (!criteria || !filterName) return null;

        // If this is a direct match (value node)
        if (criteria.cType === 'VAL' && criteria.left === filterName && criteria.right) {
            return criteria.right;
        }

        // If this is a composite node with a chain
        if ((criteria.cType === 'AND' || criteria.cType === 'OR') && Array.isArray(criteria.chain)) {
            for (let i = 0; i < criteria.chain.length; i++) {
                const result = this.getFilterValueFromListingCriteria(criteria.chain[i], filterName);
                if (result) {
                    return result;
                }
            }
        }

        return null;
    };

    this.getShortCodeId = (entityTypeId,codeId,width) => `${NumToCodeMapping[entityTypeId]}${pad(codeId,width)}`;

    /**
     * Executes a callback function when a specified channel becomes active or after a timeout.
     *
     * This function checks if the given `channelName` is currently active within the `window.sarc` object.
     * If it is, the `callbackFn` is executed immediately.
     * If not, it sets up an interval to periodically check for the channel's activation.
     * Once the channel becomes active, the interval is cleared and the `callbackFn` is executed.
     * Additionally, a timeout is set to ensure the interval doesn't run indefinitely.
     *
     * @param {string} channelName - The name of the channel to monitor for activation.
     * @param {function} callbackFn - The function to execute when the channel becomes active.
     * @param {number} [intervalTimeout=2000] - The maximum time (in milliseconds) to wait for the channel to become active.
     */
    this.sarcChannelExecutionar = (channelName,callbackFn,intervalTimeout=10000) => {
        if(window.sarc.getActiveChannels().includes(channelName) && window.sarc.getActiveSubscriptions(channelName)?.length) {
            callbackFn && callbackFn();
        }else {
            let intervalRunning = true;
            let timer = setInterval(() => {
                if(window.sarc.getActiveChannels().includes(channelName)) {
                    intervalRunning = false;
                    clearInterval(timer);
                    callbackFn && callbackFn();
                }
            },300)
            setTimeout(() => intervalRunning && clearInterval(timer),intervalTimeout)
        }
    }

    this.downloadOctetStreamFile = (fileString, documentName, extension) => {
        if(!fileString) return;

        const blobUrl = window.URL.createObjectURL(new Blob([fileString]));

        // Create a temporary anchor element to trigger the download
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = `${documentName || "file"}.${extension || "docx"}`;
        document.body.appendChild(a);
        a.click();

        // Cleanup
        a.remove();
        window.URL.revokeObjectURL(blobUrl);
    }

    this.categorizeByDate = (data, timestampKey) => {
        const now = new Date();
        const startOfToday = new Date(now.setHours(0, 0, 0, 0));
        const startOfYesterday = new Date(startOfToday);
        startOfYesterday.setDate(startOfToday.getDate() - 1);
        const sevenDaysAgo = new Date(startOfToday);
        sevenDaysAgo.setDate(startOfToday.getDate() - 7);

        const today = [];
        const yesterday = [];
        const previousSevenDays = [];
        const olderToSevenDays = [];

        data.forEach(item => {
            const dateCreated = new Date(item[timestampKey]);

            if (dateCreated >= startOfToday) {
                today.push(item);
            } else if (dateCreated >= startOfYesterday && dateCreated < startOfToday) {
                yesterday.push(item);
            } else if (dateCreated >= sevenDaysAgo && dateCreated < startOfYesterday) {
                previousSevenDays.push(item);
            } else {
                olderToSevenDays.push(item);
            }
        });

        return { today, yesterday, previousSevenDays, olderToSevenDays, all: data };
    }
    this.getNodeAppendingPosition = (node, path) => {
        let where_append = "", whereToGet = "";
        path.forEach((k, i) => {
            k = parseInt(k);
            if (i) {
                if (where_append === "") {
                    if (path.length - 1 == i && typeof node.value == "string" && node.value.indexOf("viewMore") > -1) {
                        where_append = "children" + "[" + k + "]"
                    } else {
                        whereToGet = "children" + "[" + k + "]"
                        where_append = "children" + "[" + k + "]"
                    }
                } else {
                    if (path.length - 1 == i && typeof node.value == "string" && node.value.indexOf("viewMore") > -1) {
                        where_append = where_append + ".children" + "[" + k + "]"
                    } else {
                        whereToGet = whereToGet + ".children" + "[" + k + "]"
                        where_append = where_append + ".children" + "[" + k + "]"
                    }
                }
            }
            if (!i && typeof node.value == "string" && node.value.indexOf("viewMore") > -1) {
                if (path.length <= 1) {
                    whereToGet = "";
                } else {
                    whereToGet = "children" + "[" + k + "]"
                }
                where_append = "children" + "[" + k + "]"
            }
        });
        return {where_append, whereToGet};
    };

    this.adjustPathToAppendNode = (treeJson, whereToAppend) => {
        const pathParts = whereToAppend.split('.'); // Split path into parts
        let currentNode = treeJson;

        for (let i = 0; i < pathParts.length; i++) {
            const match = pathParts[i].match(/children\[(\d+)\]/);

            if (match) {
                let index = parseInt(match[1]);

                // Check if current node has children and the first child's label is "View more"
                if (currentNode.children?.[0]?.label === "View more") {
                    index -= 1; // Decrement index
                }

                pathParts[i] = `children[${index}]`; // Update path
                currentNode = currentNode.children?.[index] || {}; // Move deeper into the tree
            }
        }

        return pathParts.join('.');
    }

    this.getActualDateFormat = () => {
        const dateFormat =  window.actualDateFormatToShow;
        return (dateFormat || "MM-DD-YYYY").replace(/d/g, "D").replace(/y/g, "Y");
    }

    this.getDateFormat = () => {
        const dateFormat =  window.actualDateFormatToShow;
        return (dateFormat || "MM-dd-yyyy").replace(/D/g, "d").replace(/Y/g, "y");
    }

    this.getActualTimeFormat = () =>  {
        const dateTimeFormat = window.actualDatetimeFormatToShow;
        const dateFormat = window.actualDateFormatToShow;
        let timeFormat = "";
        if (window.isDateTimeEnabled) {
           timeFormat = dateTimeFormat.replace(dateFormat, "").trim();
        }
        return timeFormat;
    }

    this.getActualDateTimeFormat = () =>  {
        const datetimeFormat = window.actualDatetimeFormatToShow;
        return (datetimeFormat || "MM-DD-YYYY HH:mm:ss").replace(/d/g, "D").replace(/y/g, "Y");
    }

    this.getStaticMonthYearFormat = (isYearUppercase) => isYearUppercase ? 'MMM-YYYY'  : 'MMM-yyyy';

    this.getOrdinalDateTimeFormat = () => 'Do MMMM YYYY | hh:mm A'  // eg. 1st January 2023 | 12:00 AM

    this.getDateTimeFormat = () =>  {
        const datetimeFormat = window.actualDatetimeFormatToShow
        return datetimeFormat || "MM-dd-yyyy HH:mm:ss";
    }
    this.getDBDateFormat = () => 'MM-DD-YYYY';

    this.getDBDateTimeFormat = () => 'MM-DD-YYYY HH:mm:ss';
    this.getAngularSupportDBDateTimeFormat = () => this.getDBDateTimeFormat().replace(/D/g, "d").replace(/Y/g, "y");;

    this.getLowerCaseDateFormat = () => 'mm-dd-yyyy';
    this.getLowerCaseDateTimeFormat = () => "mm-dd-yyyy HH:mm:ss";

    this.convertToDBDate = (date) => {
       const modifiedDate = moment(date.trim(), this.getActualDateFormat()).format(this.getDBDateFormat());
       return modifiedDate;
    }
    this.getDocumentTagsUrl = ()=> {
        const entityType = window.SirionUtils.appendTblToUrl(SirionUtils.getEntityTypeFromUrl());
        const entityListId = _.get(urlToEntityDataMapper,`[${entityType}].listId`);
        return `/options/155?pageType=6&entityTpeId=317&parentEntityId=&pageEntityTypeId=${urlToCodeMapper[entityType]}&fieldId=&filterId=534&offset=0&listId=${entityListId}`;
    }

    this.resetMTab = function(id, selector) {
        const sc = $(`${selector}`).scope();
        const field = sc?.mtab?.fields?.[0];
        if (field) {
            field.id = id;
        }
        sc.$apply();
    }

    this.resetDataGridTableSelectedCheckbox = () => {
        const callFn = () => window.sarc.channelBroadcast("updateGlobalListing",{actionType:'resetSelectedRows'},'updateGlobalListingSubscription');
        window.SirionUtils.sarcChannelExecutionar("updateGlobalListing",callFn);
    }
    this.getIdSelectionQueryMessage = (entityTypeId,shortCodeId) => {
        let idSelectionQuery = intl_msg[37467] || `You have selected %s. Ask about 'Contract Details' or select a document from the 'Document Repository' to continue the conversation.`;
        if(entityTypeId === 61 && shortCodeId){
            idSelectionQuery = idSelectionQuery.replace('%s', `${intl_msg[26313]} ID ${shortCodeId}`);
        } else if(entityTypeId === 160 && shortCodeId){
            idSelectionQuery = idSelectionQuery.replace('%s', `${intl_msg[9638]} ID ${shortCodeId}`);
        } else {
            idSelectionQuery = idSelectionQuery.replace('%s', `ID ${shortCodeId}`);
        }
        return idSelectionQuery;
    }
    this.docSelectionQueryMessage = (docName) => {
        let docSelectionQuery = intl_msg[37468] || `You have selected document %s. Handing over to <strong>MIRA, your AI Contract Assistant</strong>, who can help you answer questions about this document.`;
        docSelectionQuery = docSelectionQuery.replace('%s', `${docName}`);
        return docSelectionQuery;
    }
    this.formatMessage = (message, replacements) => {
        let index = 0;
        return message.replace(/%s/g, () => replacements[index++] ?? '');
    }

    this.overShadowElements = (value) => {
        let elementToOverShadow = ['#footer', '#header', '#quick_links'],
            functionName = "remove";
        if(value){
            functionName = "add";
        }
        elementToOverShadow.forEach(elemId => {
            document.querySelector(elemId).classList[functionName]('corpus_z-index-1');
        });
    }

    this.isLoadedInIframe = () => document.body.classList.contains('mobile_view') || (sessionStorage.getItem('ux3') === 'ux3' && window.parent.location.href.includes("ux3"));
    this.changeSingleQuoteToSymbol = (value="") => {
        let open = true;
        return value?.replace(/'/g, () => {
          if (open) {
            open = false;
            return '‘';
          } else {
            open = true;
            return '’'; 
          }
        }).replace(/‘(?=[^’]*$)/, '’');
    }

    this.getFieldTypeFromEditableHtmlType = (editableHtmlType) => {
        const fieldTypes = {
            1: "text",
            2: "textarea",
            3: "select",
            4: "multiselect",
            5: "checkbox",
            6: "radio",
            7: "password",
            8: "date",
            9: "hreftext",
            10: "label",
            11: "textBoxSingleSelect",
            12: "textBoxMultiSelect",
            13: "button",
            14: "fileUpload",
            15: "invoiceDynamic",
            17: "none",
            18: "number",
            19: "number",       // Currency mapped to number (as shown)
            20: "dateTime",
        };
        return fieldTypes[+editableHtmlType];
    }

    // Parses a :;-delimited composite cell value (label:;urlId:;entityTypeId) and
    // returns { label, link } for known entity types, or null for plain text values.
    // Used by both the React and legacy dynamic table popup cell renderers.
    this.parseDynamicTableCellLink = function(rawVal) {
        if (!rawVal || rawVal === '-') return null;
        var parts = rawVal.split(':;');
        if (parts.length !== 3 || !parts[1] || !parts[2]) return null;
        var seqId = parts[0];
        var urlId = parts[1];
        var entityTypeId = parts[2];
        var codePrefix = (window.NumToCodeMapping || {})[entityTypeId];
        var urlPart = (window.NumToURLPartMapping || {})[entityTypeId];
        if (!codePrefix || !urlPart) return null;
        var padWidth = entityTypeId === '316' ? 6 : 5;
        var label = codePrefix + pad(seqId, padWidth);
        var link = entityTypeId === '316'
            ? '#/autoExtraction/document/' + urlId
            : '#/show/' + urlPart + '/' + urlId;
        return { label: label, link: link };
    };

})();
